// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client'
import { client } from './client.gen'
import {
  backgroundTasksTasksRetrieveResponseTransformer,
  directoutreachBetanxtVoterPolicySnapshotExportCreateResponseTransformer,
  directoutreachPolicyAvailableListResponseTransformer,
  directoutreachPolicyAvailableRetrieveResponseTransformer,
  directoutreachPolicyCreateResponseTransformer,
  directoutreachVotersCreateCreateResponseTransformer,
  directoutreachVotersHoldingsRetrieveResponseTransformer,
  directoutreachVotersSelectedPolicyCreateResponseTransformer,
  directoutreachVotersSelectedPolicyRetrieveResponseTransformer,
  directvotingCustodyAccountsCreateResponseTransformer,
  directvotingCustodyAccountsListResponseTransformer,
  directvotingCustodyAccountsPartialUpdateResponseTransformer,
  directvotingCustodyAccountsRetrieveResponseTransformer,
  directvotingCustodyAccountsUpdateResponseTransformer,
  directvotingCustodyAccountVoterLinksLinkCreateResponseTransformer,
  directvotingCustodyAccountVoterLinksListResponseTransformer,
  directvotingCustodyAccountVotingPolicySelectionsCreateResponseTransformer,
  directvotingCustodyAccountVotingPolicySelectionsPartialUpdateResponseTransformer,
  directvotingCustodyAccountVotingPolicySelectionsRetrieveResponseTransformer,
  directvotingCustodyAccountVotingPolicySelectionsSearchCreateResponseTransformer,
  directvotingCustodyAccountVotingPolicySelectionsUpdateResponseTransformer,
  directvotingVotersBallotsCastVoteCreateResponseTransformer,
  directvotingVotersBallotsProposalsRetrieveResponseTransformer,
  directvotingVotersBallotsSearchCreateResponseTransformer,
  directvotingVotersCreateResponseTransformer,
  directvotingVotersListResponseTransformer,
  directvotingVotersMeetingsSearchCreateResponseTransformer,
  directvotingVotersPartialUpdateResponseTransformer,
  directvotingVotersRetrieveResponseTransformer,
  directvotingVotersUpdateResponseTransformer,
  fundManagerFundManagersCreateResponseTransformer,
  fundManagerFundManagersPoliciesCreateResponseTransformer,
  fundManagerFundManagersPoliciesRetrieveResponseTransformer,
  fundManagerFundManagersRetrieveResponseTransformer,
  fundManagerFundManagersSearchCreateResponseTransformer,
  fundManagerFundManagersUpdateResponseTransformer,
  fundManagerFundsCreateResponseTransformer,
  fundManagerFundsQuantificationSnapshotsCreateResponseTransformer,
  fundManagerFundsRetrieveResponseTransformer,
  fundManagerFundsSearchCreateResponseTransformer,
  fundManagerFundsUpdateResponseTransformer,
  fundManagerFundVariantsCreateResponseTransformer,
  fundManagerFundVariantsRetrieveResponseTransformer,
  fundManagerFundVariantsSearchCreateResponseTransformer,
  fundManagerFundVariantsUpdateResponseTransformer,
  fundManagerProvidersCreateResponseTransformer,
  fundManagerProvidersListResponseTransformer,
  fundManagerProvidersRetrieveResponseTransformer,
  fundManagerProvidersUpdateResponseTransformer,
  fundManagerQuantificationSnapshotsSearchCreateResponseTransformer,
  institutionalMeetingsearchListResponseTransformer,
  proxyIntermediaryBallotsFetchByVersionIdsCreateResponseTransformer,
  proxyIntermediaryBallotsSearchCreateResponseTransformer,
  proxyIntermediaryBallotsUpsertCreateResponseTransformer,
  proxyIntermediaryBallotsVersionsListResponseTransformer,
  proxyIntermediaryProposalsCreateCreateResponseTransformer,
  proxyIntermediaryProposalsSearchCreateResponseTransformer,
  proxyIntermediaryProxyIntermediariesSearchCreateResponseTransformer,
  proxyIntermediaryProxyIntermediaryMeetingsAuditEventsSearchCreateResponseTransformer,
  proxyIntermediaryProxyIntermediaryMeetingsCancelCreateResponseTransformer,
  proxyIntermediaryProxyIntermediaryMeetingsLinkTransparencyGeneralMeetingCreateResponseTransformer,
  proxyIntermediaryProxyIntermediaryMeetingsSearchCreateResponseTransformer,
  proxyIntermediaryProxyIntermediaryMeetingsUnlinkTransparencyGeneralMeetingCreateResponseTransformer,
  proxyIntermediaryProxyIntermediaryMeetingsUpsertCreateResponseTransformer,
  proxyIntermediaryProxymityVotesCreateCreateResponseTransformer,
  proxyIntermediaryProxymityVotesFetchLatestCreateResponseTransformer,
  proxyIntermediaryVoteStatusesUpsertCreateResponseTransformer,
  proxyvotingEntitlementsListResponseTransformer,
  proxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponseTransformer,
  proxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateResponseTransformer,
  proxyvotingFundManagerSupportedPoliciesCreateResponseTransformer,
  proxyvotingFundManagerSupportedPoliciesListResponseTransformer,
  proxyvotingInvestorCompositionsDifferenceListResponseTransformer,
  proxyvotingInvestorCompositionsRulesEngineRetrieveResponseTransformer,
  proxyvotingInvestorCompositionsRulesEngineUpdateResponseTransformer,
  proxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponseTransformer,
  proxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateResponseTransformer,
  proxyvotingInvestorSupportedIssuedInstrumentsCreateResponseTransformer,
  proxyvotingInvestorSupportedIssuedInstrumentsSearchCreateResponseTransformer,
  proxyvotingMeetingBallotsListResponseTransformer,
  proxyvotingMeetingBallotSourcesListResponseTransformer,
  proxyvotingPiballotsFilterListResponseTransformer,
  proxyvotingPimeetingsFilterListResponseTransformer,
  proxyvotingRulesEngineDefinitionsCreateResponseTransformer,
  proxyvotingRulesEngineDefinitionsListResponseTransformer,
  proxyvotingRulesEngineDefinitionsRetrieveResponseTransformer,
  proxyvotingRulesEngineDefinitionsRulesCreateResponseTransformer,
  proxyvotingRulesEngineDefinitionsRulesListResponseTransformer,
  proxyvotingRulesEngineDefinitionsRulesUpdateResponseTransformer,
  proxyvotingSviProposalOverwriteCreateResponseTransformer,
  transparencyAuditEventsSearchCreateResponseTransformer,
  transparencyExternalMeetingIdsCreateResponseTransformer,
  transparencyGeneralMeetingsCreateResponseTransformer,
  transparencyGeneralMeetingsPartialUpdateResponseTransformer,
  transparencyGeneralMeetingsRetrieveResponseTransformer,
  transparencyGeneralMeetingsSearchCreateResponseTransformer,
  transparencyOrganizationsCreateResponseTransformer,
  transparencyOrganizationsGeneralMeetingsProposalsCreateResponseTransformer,
  transparencyOrganizationsGeneralMeetingsProposalsPartialUpdateResponseTransformer,
  transparencyOrganizationsGeneralMeetingsProposalsRetrieveResponseTransformer,
  transparencyOrganizationsGeneralMeetingsProposalsSearchCreateResponseTransformer,
  transparencyOrganizationsGeneralMeetingsProposalsUpdateResponseTransformer,
  transparencyOrganizationsGetByIdentifierCreateResponseTransformer,
  transparencyOrganizationsLogoCreateResponseTransformer,
  transparencyOrganizationsPartialUpdateResponseTransformer,
  transparencyOrganizationsRetrieveResponseTransformer,
  transparencyOrganizationsSearchCreateResponseTransformer,
  transparencyOrganizationsUpdateResponseTransformer,
  transparencyProposalsFetchCreateResponseTransformer,
  transparencyPublicSecurityIdsSearchCreateResponseTransformer,
  votingOperationsPiballotsFilterListResponseTransformer,
  votingOperationsPimeetingsFilterListResponseTransformer,
  votingPolicyProposalSetRecommendationCoverageDetailRetrieveResponseTransformer,
  votingPolicyProposalSetRecommendationCoverageSearchCreateResponseTransformer,
  votingPolicyProviderVotingRecommendationsCreateResponseTransformer,
  votingPolicyProviderVotingRecommendationsFetchByVersionRetrieveResponseTransformer,
  votingPolicyProviderVotingRecommendationsMatchCreateResponseTransformer,
  votingPolicyProviderVotingRecommendationsSearchCreateResponseTransformer,
  votingPolicyProxyIntermediaryVotingRecommendationConfidenceScoresUpdateResponseTransformer,
  votingPolicyProxyIntermediaryVotingRecommendationsCreateResponseTransformer,
  votingPolicyProxyIntermediaryVotingRecommendationsMatchFromPvrCreateResponseTransformer,
  votingPolicyProxyIntermediaryVotingRecommendationsSearchCreateResponseTransformer,
  votingPolicyProxyIntermediaryVotingRecommendationsVersionsRetrieveResponseTransformer,
  votingPolicyProxyIntermediaryVotingRecommendationValidationStatusesCreateResponseTransformer,
  votingPolicyProxyIntermediaryVotingRecommendationValidationStatusesSearchCreateResponseTransformer,
  votingPolicyVotingPoliciesCreateResponseTransformer,
  votingPolicyVotingPoliciesDocumentsCreateResponseTransformer,
  votingPolicyVotingPoliciesDocumentsListResponseTransformer,
  votingPolicyVotingPoliciesDocumentsPartialUpdateResponseTransformer,
  votingPolicyVotingPoliciesDocumentsRetrieveResponseTransformer,
  votingPolicyVotingPoliciesPartialUpdateResponseTransformer,
  votingPolicyVotingPoliciesRetrieveResponseTransformer,
  votingPolicyVotingPoliciesSearchCreateResponseTransformer,
  votingPolicyVotingPoliciesVotingRecommendationsCreateResponseTransformer,
  votingPolicyVotingPoliciesVotingRecommendationsPartialUpdateResponseTransformer,
  votingPolicyVotingPoliciesVotingRecommendationsRetrieveResponseTransformer,
  votingPolicyVotingPoliciesVotingRecommendationsSearchCreateResponseTransformer,
  votingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateResponseTransformer,
  votingPolicyVotingRecommendationConfidenceScoresUpdateResponseTransformer,
} from './transformers.gen'
import type {
  ApiSchemaRetrieveData,
  ApiSchemaRetrieveResponses,
  BackgroundTasksTasksRetrieveData,
  BackgroundTasksTasksRetrieveErrors,
  BackgroundTasksTasksRetrieveResponses,
  DirectoutreachBetanxtVoterPolicySnapshotExportCreateData,
  DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponses,
  DirectoutreachPolicyAvailableListData,
  DirectoutreachPolicyAvailableListResponses,
  DirectoutreachPolicyAvailableRetrieveData,
  DirectoutreachPolicyAvailableRetrieveResponses,
  DirectoutreachPolicyCreateData,
  DirectoutreachPolicyCreateResponses,
  DirectoutreachVotersBatchCreateCreateData,
  DirectoutreachVotersBatchCreateCreateErrors,
  DirectoutreachVotersBatchCreateCreateResponses,
  DirectoutreachVotersCreateCreateData,
  DirectoutreachVotersCreateCreateResponses,
  DirectoutreachVotersHoldingsRetrieveData,
  DirectoutreachVotersHoldingsRetrieveErrors,
  DirectoutreachVotersHoldingsRetrieveResponses,
  DirectoutreachVotersRetrieveData,
  DirectoutreachVotersRetrieveErrors,
  DirectoutreachVotersRetrieveResponses,
  DirectoutreachVotersSelectedPolicyCreateData,
  DirectoutreachVotersSelectedPolicyCreateErrors,
  DirectoutreachVotersSelectedPolicyCreateResponses,
  DirectoutreachVotersSelectedPolicyRetrieveData,
  DirectoutreachVotersSelectedPolicyRetrieveErrors,
  DirectoutreachVotersSelectedPolicyRetrieveResponses,
  DirectvotingCustodyAccountsCreateData,
  DirectvotingCustodyAccountsCreateErrors,
  DirectvotingCustodyAccountsCreateResponses,
  DirectvotingCustodyAccountsDestroyData,
  DirectvotingCustodyAccountsDestroyErrors,
  DirectvotingCustodyAccountsDestroyResponses,
  DirectvotingCustodyAccountsListData,
  DirectvotingCustodyAccountsListErrors,
  DirectvotingCustodyAccountsListResponses,
  DirectvotingCustodyAccountsPartialUpdateData,
  DirectvotingCustodyAccountsPartialUpdateErrors,
  DirectvotingCustodyAccountsPartialUpdateResponses,
  DirectvotingCustodyAccountsRetrieveData,
  DirectvotingCustodyAccountsRetrieveErrors,
  DirectvotingCustodyAccountsRetrieveResponses,
  DirectvotingCustodyAccountsUpdateData,
  DirectvotingCustodyAccountsUpdateErrors,
  DirectvotingCustodyAccountsUpdateResponses,
  DirectvotingCustodyAccountVoterLinksLinkCreateData,
  DirectvotingCustodyAccountVoterLinksLinkCreateErrors,
  DirectvotingCustodyAccountVoterLinksLinkCreateResponses,
  DirectvotingCustodyAccountVoterLinksListData,
  DirectvotingCustodyAccountVoterLinksListErrors,
  DirectvotingCustodyAccountVoterLinksListResponses,
  DirectvotingCustodyAccountVoterLinksUnlinkCreateData,
  DirectvotingCustodyAccountVoterLinksUnlinkCreateErrors,
  DirectvotingCustodyAccountVoterLinksUnlinkCreateResponses,
  DirectvotingCustodyAccountVotingPolicySelectionsCreateData,
  DirectvotingCustodyAccountVotingPolicySelectionsCreateErrors,
  DirectvotingCustodyAccountVotingPolicySelectionsCreateResponses,
  DirectvotingCustodyAccountVotingPolicySelectionsDestroyData,
  DirectvotingCustodyAccountVotingPolicySelectionsDestroyErrors,
  DirectvotingCustodyAccountVotingPolicySelectionsDestroyResponses,
  DirectvotingCustodyAccountVotingPolicySelectionsPartialUpdateData,
  DirectvotingCustodyAccountVotingPolicySelectionsPartialUpdateErrors,
  DirectvotingCustodyAccountVotingPolicySelectionsPartialUpdateResponses,
  DirectvotingCustodyAccountVotingPolicySelectionsRetrieveData,
  DirectvotingCustodyAccountVotingPolicySelectionsRetrieveErrors,
  DirectvotingCustodyAccountVotingPolicySelectionsRetrieveResponses,
  DirectvotingCustodyAccountVotingPolicySelectionsSearchCreateData,
  DirectvotingCustodyAccountVotingPolicySelectionsSearchCreateErrors,
  DirectvotingCustodyAccountVotingPolicySelectionsSearchCreateResponses,
  DirectvotingCustodyAccountVotingPolicySelectionsUpdateData,
  DirectvotingCustodyAccountVotingPolicySelectionsUpdateErrors,
  DirectvotingCustodyAccountVotingPolicySelectionsUpdateResponses,
  DirectvotingVotersBallotsCastVoteCreateData,
  DirectvotingVotersBallotsCastVoteCreateErrors,
  DirectvotingVotersBallotsCastVoteCreateResponses,
  DirectvotingVotersBallotsProposalsRetrieveData,
  DirectvotingVotersBallotsProposalsRetrieveErrors,
  DirectvotingVotersBallotsProposalsRetrieveResponses,
  DirectvotingVotersBallotsSearchCreateData,
  DirectvotingVotersBallotsSearchCreateErrors,
  DirectvotingVotersBallotsSearchCreateResponses,
  DirectvotingVotersCreateData,
  DirectvotingVotersCreateResponses,
  DirectvotingVotersDestroyData,
  DirectvotingVotersDestroyResponses,
  DirectvotingVotersListData,
  DirectvotingVotersListResponses,
  DirectvotingVotersMeetingsSearchCreateData,
  DirectvotingVotersMeetingsSearchCreateErrors,
  DirectvotingVotersMeetingsSearchCreateResponses,
  DirectvotingVotersPartialUpdateData,
  DirectvotingVotersPartialUpdateResponses,
  DirectvotingVotersRetrieveData,
  DirectvotingVotersRetrieveResponses,
  DirectvotingVotersUpdateData,
  DirectvotingVotersUpdateResponses,
  FundManagerFundManagersCreateData,
  FundManagerFundManagersCreateResponses,
  FundManagerFundManagersPoliciesCreateData,
  FundManagerFundManagersPoliciesCreateResponses,
  FundManagerFundManagersPoliciesRetrieveData,
  FundManagerFundManagersPoliciesRetrieveResponses,
  FundManagerFundManagersRetrieveData,
  FundManagerFundManagersRetrieveResponses,
  FundManagerFundManagersSearchCreateData,
  FundManagerFundManagersSearchCreateResponses,
  FundManagerFundManagersUpdateData,
  FundManagerFundManagersUpdateResponses,
  FundManagerFundsCreateData,
  FundManagerFundsCreateResponses,
  FundManagerFundsQuantificationSnapshotsCreateData,
  FundManagerFundsQuantificationSnapshotsCreateResponses,
  FundManagerFundsRetrieveData,
  FundManagerFundsRetrieveResponses,
  FundManagerFundsSearchCreateData,
  FundManagerFundsSearchCreateResponses,
  FundManagerFundsUpdateData,
  FundManagerFundsUpdateResponses,
  FundManagerFundVariantsCreateData,
  FundManagerFundVariantsCreateResponses,
  FundManagerFundVariantsDestroyData,
  FundManagerFundVariantsDestroyResponses,
  FundManagerFundVariantsRetrieveData,
  FundManagerFundVariantsRetrieveResponses,
  FundManagerFundVariantsSearchCreateData,
  FundManagerFundVariantsSearchCreateResponses,
  FundManagerFundVariantsUpdateData,
  FundManagerFundVariantsUpdateResponses,
  FundManagerProvidersCreateData,
  FundManagerProvidersCreateResponses,
  FundManagerProvidersListData,
  FundManagerProvidersListResponses,
  FundManagerProvidersRetrieveData,
  FundManagerProvidersRetrieveResponses,
  FundManagerProvidersUpdateData,
  FundManagerProvidersUpdateResponses,
  FundManagerQuantificationSnapshotsSearchCreateData,
  FundManagerQuantificationSnapshotsSearchCreateResponses,
  InstitutionalMeetingsearchListData,
  InstitutionalMeetingsearchListResponses,
  ProxyIntermediaryBallotsFetchByVersionIdsCreateData,
  ProxyIntermediaryBallotsFetchByVersionIdsCreateResponses,
  ProxyIntermediaryBallotsSearchCreateData,
  ProxyIntermediaryBallotsSearchCreateResponses,
  ProxyIntermediaryBallotsUpsertCreateData,
  ProxyIntermediaryBallotsUpsertCreateResponses,
  ProxyIntermediaryBallotsVersionsListData,
  ProxyIntermediaryBallotsVersionsListResponses,
  ProxyIntermediaryProposalCategoriesAssignCreateData,
  ProxyIntermediaryProposalCategoriesAssignCreateResponses,
  ProxyIntermediaryProposalCategoriesListCreateData,
  ProxyIntermediaryProposalCategoriesListCreateResponses,
  ProxyIntermediaryProposalLabelsAssignCreateData,
  ProxyIntermediaryProposalLabelsAssignCreateResponses,
  ProxyIntermediaryProposalLabelsFetchCreateData,
  ProxyIntermediaryProposalLabelsFetchCreateResponses,
  ProxyIntermediaryProposalsCreateCreateData,
  ProxyIntermediaryProposalsCreateCreateResponses,
  ProxyIntermediaryProposalsDeleteCreateData,
  ProxyIntermediaryProposalsDeleteCreateResponses,
  ProxyIntermediaryProposalsSearchCreateData,
  ProxyIntermediaryProposalsSearchCreateResponses,
  ProxyIntermediaryProxyIntermediariesSearchCreateData,
  ProxyIntermediaryProxyIntermediariesSearchCreateResponses,
  ProxyIntermediaryProxyIntermediaryMeetingsAuditEventsSearchCreateData,
  ProxyIntermediaryProxyIntermediaryMeetingsAuditEventsSearchCreateResponses,
  ProxyIntermediaryProxyIntermediaryMeetingsCancelCreateData,
  ProxyIntermediaryProxyIntermediaryMeetingsCancelCreateResponses,
  ProxyIntermediaryProxyIntermediaryMeetingsLinkTransparencyGeneralMeetingCreateData,
  ProxyIntermediaryProxyIntermediaryMeetingsLinkTransparencyGeneralMeetingCreateResponses,
  ProxyIntermediaryProxyIntermediaryMeetingsSearchCreateData,
  ProxyIntermediaryProxyIntermediaryMeetingsSearchCreateResponses,
  ProxyIntermediaryProxyIntermediaryMeetingsUnlinkTransparencyGeneralMeetingCreateData,
  ProxyIntermediaryProxyIntermediaryMeetingsUnlinkTransparencyGeneralMeetingCreateResponses,
  ProxyIntermediaryProxyIntermediaryMeetingsUpsertCreateData,
  ProxyIntermediaryProxyIntermediaryMeetingsUpsertCreateResponses,
  ProxyIntermediaryProxymityVotesCreateCreateData,
  ProxyIntermediaryProxymityVotesCreateCreateResponses,
  ProxyIntermediaryProxymityVotesFetchLatestCreateData,
  ProxyIntermediaryProxymityVotesFetchLatestCreateResponses,
  ProxyIntermediaryVoteStatusesDeleteCreateData,
  ProxyIntermediaryVoteStatusesDeleteCreateResponses,
  ProxyIntermediaryVoteStatusesUpsertCreateData,
  ProxyIntermediaryVoteStatusesUpsertCreateResponses,
  ProxyvotingEntitlementsBreakdownCreateData,
  ProxyvotingEntitlementsBreakdownCreateResponses,
  ProxyvotingEntitlementsComputeCreateData,
  ProxyvotingEntitlementsComputeCreateResponses,
  ProxyvotingEntitlementsListData,
  ProxyvotingEntitlementsListResponses,
  ProxyvotingFundManagerCompositionsSiiFromCompositionDifferenceCreateData,
  ProxyvotingFundManagerCompositionsSiiFromCompositionDifferenceCreateResponses,
  ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateData,
  ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses,
  ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateData,
  ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponses,
  ProxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateData,
  ProxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateResponses,
  ProxyvotingFundManagerSupportedPoliciesCreateData,
  ProxyvotingFundManagerSupportedPoliciesCreateResponses,
  ProxyvotingFundManagerSupportedPoliciesDestroyData,
  ProxyvotingFundManagerSupportedPoliciesDestroyResponses,
  ProxyvotingFundManagerSupportedPoliciesListData,
  ProxyvotingFundManagerSupportedPoliciesListResponses,
  ProxyvotingInvestorCompositionsDifferenceListData,
  ProxyvotingInvestorCompositionsDifferenceListResponses,
  ProxyvotingInvestorCompositionsRenderCreateData,
  ProxyvotingInvestorCompositionsRenderCreateResponses,
  ProxyvotingInvestorCompositionsRulesEngineRetrieveData,
  ProxyvotingInvestorCompositionsRulesEngineRetrieveResponses,
  ProxyvotingInvestorCompositionsRulesEngineUpdateData,
  ProxyvotingInvestorCompositionsRulesEngineUpdateResponses,
  ProxyvotingInvestorCompositionsSiiFromCompositionDifferenceCreateData,
  ProxyvotingInvestorCompositionsSiiFromCompositionDifferenceCreateResponses,
  ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateData,
  ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses,
  ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateData,
  ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponses,
  ProxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateData,
  ProxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateResponses,
  ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateData,
  ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateResponses,
  ProxyvotingInvestorSupportedIssuedInstrumentsCreateData,
  ProxyvotingInvestorSupportedIssuedInstrumentsCreateResponses,
  ProxyvotingInvestorSupportedIssuedInstrumentsSearchCreateData,
  ProxyvotingInvestorSupportedIssuedInstrumentsSearchCreateResponses,
  ProxyvotingMeetingballotsComputeCreateData,
  ProxyvotingMeetingballotsComputeCreateResponses,
  ProxyvotingMeetingBallotsListData,
  ProxyvotingMeetingBallotsListResponses,
  ProxyvotingMeetingBallotSourcesListData,
  ProxyvotingMeetingBallotSourcesListResponses,
  ProxyvotingPiballotsFilterListData,
  ProxyvotingPiballotsFilterListResponses,
  ProxyvotingPiballotsInvestorsCanVoteCreateData,
  ProxyvotingPiballotsInvestorsCanVoteCreateResponses,
  ProxyvotingPimeetingsFilterListData,
  ProxyvotingPimeetingsFilterListResponses,
  ProxyvotingRulesEngineDefinitionsByNameDestroyData,
  ProxyvotingRulesEngineDefinitionsByNameDestroyErrors,
  ProxyvotingRulesEngineDefinitionsByNameDestroyResponses,
  ProxyvotingRulesEngineDefinitionsCreateData,
  ProxyvotingRulesEngineDefinitionsCreateResponses,
  ProxyvotingRulesEngineDefinitionsDestroyData,
  ProxyvotingRulesEngineDefinitionsDestroyErrors,
  ProxyvotingRulesEngineDefinitionsDestroyResponses,
  ProxyvotingRulesEngineDefinitionsListData,
  ProxyvotingRulesEngineDefinitionsListResponses,
  ProxyvotingRulesEngineDefinitionsNamesRetrieveData,
  ProxyvotingRulesEngineDefinitionsNamesRetrieveResponses,
  ProxyvotingRulesEngineDefinitionsRetrieveData,
  ProxyvotingRulesEngineDefinitionsRetrieveResponses,
  ProxyvotingRulesEngineDefinitionsRulesCreateData,
  ProxyvotingRulesEngineDefinitionsRulesCreateResponses,
  ProxyvotingRulesEngineDefinitionsRulesDestroyData,
  ProxyvotingRulesEngineDefinitionsRulesDestroyResponses,
  ProxyvotingRulesEngineDefinitionsRulesListData,
  ProxyvotingRulesEngineDefinitionsRulesListResponses,
  ProxyvotingRulesEngineDefinitionsRulesUpdateData,
  ProxyvotingRulesEngineDefinitionsRulesUpdateResponses,
  ProxyvotingSviProposalOverwriteCreateData,
  ProxyvotingSviProposalOverwriteCreateResponses,
  ProxyvotingSviProposalOverwriteReasonsListData,
  ProxyvotingSviProposalOverwriteReasonsListResponses,
  TransparencyAuditEventsSearchCreateData,
  TransparencyAuditEventsSearchCreateResponses,
  TransparencyExternalMeetingIdsCreateData,
  TransparencyExternalMeetingIdsCreateResponses,
  TransparencyExternalMeetingIdsDestroyData,
  TransparencyExternalMeetingIdsDestroyResponses,
  TransparencyGeneralMeetingsCreateData,
  TransparencyGeneralMeetingsCreateResponses,
  TransparencyGeneralMeetingsPartialUpdateData,
  TransparencyGeneralMeetingsPartialUpdateResponses,
  TransparencyGeneralMeetingsRetrieveData,
  TransparencyGeneralMeetingsRetrieveResponses,
  TransparencyGeneralMeetingsSearchCreateData,
  TransparencyGeneralMeetingsSearchCreateResponses,
  TransparencyInstrumentsCreateData,
  TransparencyInstrumentsCreateResponses,
  TransparencyInstrumentsDestroyData,
  TransparencyInstrumentsDestroyResponses,
  TransparencyInstrumentsFetchMinimalCreateData,
  TransparencyInstrumentsFetchMinimalCreateResponses,
  TransparencyInstrumentsRetrieveData,
  TransparencyInstrumentsRetrieveResponses,
  TransparencyInstrumentsSearchCreateData,
  TransparencyInstrumentsSearchCreateResponses,
  TransparencyInstrumentsUnassociatedRetrieveData,
  TransparencyInstrumentsUnassociatedRetrieveResponses,
  TransparencyInstrumentsUpdateData,
  TransparencyInstrumentsUpdateResponses,
  TransparencyOrganizationsCreateData,
  TransparencyOrganizationsCreateResponses,
  TransparencyOrganizationsDestroyData,
  TransparencyOrganizationsDestroyResponses,
  TransparencyOrganizationsGeneralMeetingsProposalsCreateData,
  TransparencyOrganizationsGeneralMeetingsProposalsCreateResponses,
  TransparencyOrganizationsGeneralMeetingsProposalsPartialUpdateData,
  TransparencyOrganizationsGeneralMeetingsProposalsPartialUpdateResponses,
  TransparencyOrganizationsGeneralMeetingsProposalsRetrieveData,
  TransparencyOrganizationsGeneralMeetingsProposalsRetrieveResponses,
  TransparencyOrganizationsGeneralMeetingsProposalsSearchCreateData,
  TransparencyOrganizationsGeneralMeetingsProposalsSearchCreateResponses,
  TransparencyOrganizationsGeneralMeetingsProposalsUpdateData,
  TransparencyOrganizationsGeneralMeetingsProposalsUpdateResponses,
  TransparencyOrganizationsGetByIdentifierCreateData,
  TransparencyOrganizationsGetByIdentifierCreateResponses,
  TransparencyOrganizationsIsinsToNamesCreateData,
  TransparencyOrganizationsIsinsToNamesCreateResponses,
  TransparencyOrganizationsLogoCreateData,
  TransparencyOrganizationsLogoCreateResponses,
  TransparencyOrganizationsPartialUpdateData,
  TransparencyOrganizationsPartialUpdateResponses,
  TransparencyOrganizationsRetrieveData,
  TransparencyOrganizationsRetrieveResponses,
  TransparencyOrganizationsSearchCreateData,
  TransparencyOrganizationsSearchCreateResponses,
  TransparencyOrganizationsUpdateData,
  TransparencyOrganizationsUpdateResponses,
  TransparencyProposalsClassificationCodesRetrieveData,
  TransparencyProposalsClassificationCodesRetrieveResponses,
  TransparencyProposalsCountCreateData,
  TransparencyProposalsCountCreateResponses,
  TransparencyProposalsFetchCreateData,
  TransparencyProposalsFetchCreateResponses,
  TransparencyProposalsFetchNamesFromIdsCreateData,
  TransparencyProposalsFetchNamesFromIdsCreateResponses,
  TransparencyProposalsSecClassificationCodesRetrieveData,
  TransparencyProposalsSecClassificationCodesRetrieveResponses,
  TransparencyPublicSecurityIdsSearchCreateData,
  TransparencyPublicSecurityIdsSearchCreateResponses,
  VotingOperationsPiballotsFilterListData,
  VotingOperationsPiballotsFilterListResponses,
  VotingOperationsPimeetingsFilterListData,
  VotingOperationsPimeetingsFilterListResponses,
  VotingPolicyProposalSetRecommendationCoverageDetailRetrieveData,
  VotingPolicyProposalSetRecommendationCoverageDetailRetrieveResponses,
  VotingPolicyProposalSetRecommendationCoverageSearchCreateData,
  VotingPolicyProposalSetRecommendationCoverageSearchCreateErrors,
  VotingPolicyProposalSetRecommendationCoverageSearchCreateResponses,
  VotingPolicyProviderVotingRecommendationsCreateData,
  VotingPolicyProviderVotingRecommendationsCreateResponses,
  VotingPolicyProviderVotingRecommendationsDestroyData,
  VotingPolicyProviderVotingRecommendationsDestroyResponses,
  VotingPolicyProviderVotingRecommendationsFetchByVersionRetrieveData,
  VotingPolicyProviderVotingRecommendationsFetchByVersionRetrieveResponses,
  VotingPolicyProviderVotingRecommendationsMatchCreateData,
  VotingPolicyProviderVotingRecommendationsMatchCreateResponses,
  VotingPolicyProviderVotingRecommendationsSearchCreateData,
  VotingPolicyProviderVotingRecommendationsSearchCreateResponses,
  VotingPolicyProxyIntermediaryVotingRecommendationConfidenceScoresUpdateData,
  VotingPolicyProxyIntermediaryVotingRecommendationConfidenceScoresUpdateResponses,
  VotingPolicyProxyIntermediaryVotingRecommendationsCreateData,
  VotingPolicyProxyIntermediaryVotingRecommendationsCreateResponses,
  VotingPolicyProxyIntermediaryVotingRecommendationsDestroyData,
  VotingPolicyProxyIntermediaryVotingRecommendationsDestroyResponses,
  VotingPolicyProxyIntermediaryVotingRecommendationsMatchFromPvrCreateData,
  VotingPolicyProxyIntermediaryVotingRecommendationsMatchFromPvrCreateResponses,
  VotingPolicyProxyIntermediaryVotingRecommendationsSearchCreateData,
  VotingPolicyProxyIntermediaryVotingRecommendationsSearchCreateResponses,
  VotingPolicyProxyIntermediaryVotingRecommendationsVersionsRetrieveData,
  VotingPolicyProxyIntermediaryVotingRecommendationsVersionsRetrieveResponses,
  VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesCreateData,
  VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesCreateResponses,
  VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesSearchCreateData,
  VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesSearchCreateResponses,
  VotingPolicyVotingPoliciesCreateData,
  VotingPolicyVotingPoliciesCreateResponses,
  VotingPolicyVotingPoliciesDestroyData,
  VotingPolicyVotingPoliciesDestroyResponses,
  VotingPolicyVotingPoliciesDocumentsCreateData,
  VotingPolicyVotingPoliciesDocumentsCreateResponses,
  VotingPolicyVotingPoliciesDocumentsListData,
  VotingPolicyVotingPoliciesDocumentsListResponses,
  VotingPolicyVotingPoliciesDocumentsPartialUpdateData,
  VotingPolicyVotingPoliciesDocumentsPartialUpdateResponses,
  VotingPolicyVotingPoliciesDocumentsRetrieveData,
  VotingPolicyVotingPoliciesDocumentsRetrieveResponses,
  VotingPolicyVotingPoliciesPartialUpdateData,
  VotingPolicyVotingPoliciesPartialUpdateResponses,
  VotingPolicyVotingPoliciesRetrieveData,
  VotingPolicyVotingPoliciesRetrieveResponses,
  VotingPolicyVotingPoliciesSearchCreateData,
  VotingPolicyVotingPoliciesSearchCreateResponses,
  VotingPolicyVotingPoliciesVotingRecommendationsCreateData,
  VotingPolicyVotingPoliciesVotingRecommendationsCreateResponses,
  VotingPolicyVotingPoliciesVotingRecommendationsDestroyData,
  VotingPolicyVotingPoliciesVotingRecommendationsDestroyResponses,
  VotingPolicyVotingPoliciesVotingRecommendationsPartialUpdateData,
  VotingPolicyVotingPoliciesVotingRecommendationsPartialUpdateResponses,
  VotingPolicyVotingPoliciesVotingRecommendationsRetrieveData,
  VotingPolicyVotingPoliciesVotingRecommendationsRetrieveResponses,
  VotingPolicyVotingPoliciesVotingRecommendationsSearchCreateData,
  VotingPolicyVotingPoliciesVotingRecommendationsSearchCreateResponses,
  VotingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateData,
  VotingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateResponses,
  VotingPolicyVotingRecommendationConfidenceScoresUpdateData,
  VotingPolicyVotingRecommendationConfidenceScoresUpdateResponses,
} from './types.gen'

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>
}

/**
 * OpenApi3 schema for this API. Format can be selected via content negotiation.
 *
 * - YAML: application/vnd.oai.openapi
 * - JSON: application/vnd.oai.openapi+json
 */
export const apiSchemaRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<ApiSchemaRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<ApiSchemaRetrieveResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/schema/',
    ...options,
  })

/**
 * Get task status
 *
 * Retrieve the current status and result of a background task by its ID.
 */
export const backgroundTasksTasksRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<BackgroundTasksTasksRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    BackgroundTasksTasksRetrieveResponses,
    BackgroundTasksTasksRetrieveErrors,
    ThrowOnError
  >({
    responseTransformer: backgroundTasksTasksRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/background-tasks/tasks/{task_id}/',
    ...options,
  })

/**
 * Export BetaNXT voter policies snapshot to S3
 *
 * Exports voter policies data to S3 as CSV. Includes holdings for the specified valid_time with policy selections. When multiple holdings exist for the same date, selects the most recent. Synchronous operation with 60s timeout. Requires timezone-aware datetime.
 */
export const directoutreachBetanxtVoterPolicySnapshotExportCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectoutreachBetanxtVoterPolicySnapshotExportCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<DirectoutreachBetanxtVoterPolicySnapshotExportCreateResponses, unknown, ThrowOnError>(
    {
      responseTransformer: directoutreachBetanxtVoterPolicySnapshotExportCreateResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/directoutreach/betanxt/voter-policy-snapshot:export/',
      ...options,
    }
  )

/**
 * Create a new voting policy
 *
 * Creates a new voting policy with the provided information.
 */
export const directoutreachPolicyCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectoutreachPolicyCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<DirectoutreachPolicyCreateResponses, unknown, ThrowOnError>({
    responseTransformer: directoutreachPolicyCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directoutreach/policy/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List all available voting policies
 *
 * Retrieves a list of all voting available policies.
 */
export const directoutreachPolicyAvailableList = <ThrowOnError extends boolean = false>(
  options?: Options<DirectoutreachPolicyAvailableListData, ThrowOnError>
) =>
  (options?.client ?? client).get<DirectoutreachPolicyAvailableListResponses, unknown, ThrowOnError>({
    responseTransformer: directoutreachPolicyAvailableListResponseTransformer,
    security: [{ name: 'X-Direct-Outreach-Token', type: 'apiKey' }],
    url: '/directoutreach/policy/available/',
    ...options,
  })

/**
 * ViewSet for retrieving available voting policies.
 */
export const directoutreachPolicyAvailableRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<DirectoutreachPolicyAvailableRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<DirectoutreachPolicyAvailableRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: directoutreachPolicyAvailableRetrieveResponseTransformer,
    security: [{ name: 'X-Direct-Outreach-Token', type: 'apiKey' }],
    url: '/directoutreach/policy/available/{id}/',
    ...options,
  })

/**
 * Get voter's details
 *
 * Retrieves the details for the specified voter, including their ID and broker ID. Use 'mine' as the voter ID to get your own details.
 */
export const directoutreachVotersRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<DirectoutreachVotersRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DirectoutreachVotersRetrieveResponses,
    DirectoutreachVotersRetrieveErrors,
    ThrowOnError
  >({
    security: [{ name: 'X-Direct-Outreach-Token', type: 'apiKey' }],
    url: '/directoutreach/voters/{id}/',
    ...options,
  })

/**
 * List latest voter's holdings
 *
 * Retrieves the holdings for the specified voter. Use 'mine' as the voter ID to get your own holdings.
 */
export const directoutreachVotersHoldingsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<DirectoutreachVotersHoldingsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DirectoutreachVotersHoldingsRetrieveResponses,
    DirectoutreachVotersHoldingsRetrieveErrors,
    ThrowOnError
  >({
    responseTransformer: directoutreachVotersHoldingsRetrieveResponseTransformer,
    security: [{ name: 'X-Direct-Outreach-Token', type: 'apiKey' }],
    url: '/directoutreach/voters/{id}/holdings/',
    ...options,
  })

/**
 * Get voter's selected policy
 *
 * Retrieves the voting policy selected by the specified voter. Use 'mine' as the voter ID to get your own selected policy.
 */
export const directoutreachVotersSelectedPolicyRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<DirectoutreachVotersSelectedPolicyRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DirectoutreachVotersSelectedPolicyRetrieveResponses,
    DirectoutreachVotersSelectedPolicyRetrieveErrors,
    ThrowOnError
  >({
    responseTransformer: directoutreachVotersSelectedPolicyRetrieveResponseTransformer,
    security: [{ name: 'X-Direct-Outreach-Token', type: 'apiKey' }],
    url: '/directoutreach/voters/{id}/selected-policy/',
    ...options,
  })

/**
 * Create a new selected policy version
 *
 * Creates a new selected policy record for the specified voter. Use 'mine' as the voter ID to create your own selected policy.
 */
export const directoutreachVotersSelectedPolicyCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectoutreachVotersSelectedPolicyCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectoutreachVotersSelectedPolicyCreateResponses,
    DirectoutreachVotersSelectedPolicyCreateErrors,
    ThrowOnError
  >({
    responseTransformer: directoutreachVotersSelectedPolicyCreateResponseTransformer,
    security: [{ name: 'X-Direct-Outreach-Token', type: 'apiKey' }],
    url: '/directoutreach/voters/{id}/selected-policy/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Batch create voters with holdings (atomic)
 *
 * Atomically creates or updates multiple voters and their holdings.
 *
 * Each voter is identified by (mediant_id, broker_id). Holdings are created as new records, preserving complete historical data.
 */
export const directoutreachVotersBatchCreateCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectoutreachVotersBatchCreateCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectoutreachVotersBatchCreateCreateResponses,
    DirectoutreachVotersBatchCreateCreateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directoutreach/voters:batch-create/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Upsert voter with holdings
 *
 * Creates or updates a voter and creates new version of their holdings. Voters are identified by (mediant_id, broker_id). Each request creates new holding records, preserving complete historical data. Queries return only the latest version of each holding.
 *
 *
 */
export const directoutreachVotersCreateCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectoutreachVotersCreateCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<DirectoutreachVotersCreateCreateResponses, unknown, ThrowOnError>({
    responseTransformer: directoutreachVotersCreateCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directoutreach/voters:create/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List custody account voter links
 */
export const directvotingCustodyAccountVoterLinksList = <ThrowOnError extends boolean = false>(
  options?: Options<DirectvotingCustodyAccountVoterLinksListData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    DirectvotingCustodyAccountVoterLinksListResponses,
    DirectvotingCustodyAccountVoterLinksListErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingCustodyAccountVoterLinksListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/custody-account-voter-links/',
    ...options,
  })

/**
 * Link a custody account to a voter
 *
 * Link a custody account to the voter that owns it. If the account is already linked to the same voter the existing link is returned unchanged; linking it to a different voter is rejected.
 */
export const directvotingCustodyAccountVoterLinksLinkCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingCustodyAccountVoterLinksLinkCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectvotingCustodyAccountVoterLinksLinkCreateResponses,
    DirectvotingCustodyAccountVoterLinksLinkCreateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingCustodyAccountVoterLinksLinkCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/custody-account-voter-links/link/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Unlink a custody account from its voter
 *
 * Remove the link between a custody account and its voter.
 */
export const directvotingCustodyAccountVoterLinksUnlinkCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingCustodyAccountVoterLinksUnlinkCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectvotingCustodyAccountVoterLinksUnlinkCreateResponses,
    DirectvotingCustodyAccountVoterLinksUnlinkCreateErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/custody-account-voter-links/unlink/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create a custody account voting policy selection
 *
 * Creates the first version of a selection for a custody account. A custody account may have at most one current selection; creating a second is a conflict until the first is deleted.
 */
export const directvotingCustodyAccountVotingPolicySelectionsCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingCustodyAccountVotingPolicySelectionsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectvotingCustodyAccountVotingPolicySelectionsCreateResponses,
    DirectvotingCustodyAccountVotingPolicySelectionsCreateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingCustodyAccountVotingPolicySelectionsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/custody-account-voting-policy-selections/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a custody account voting policy selection
 *
 * Closes the current version, leaving the identity and all version history in place. The selection then no longer appears in search or retrieve, and the custody account is free to be selected again.
 */
export const directvotingCustodyAccountVotingPolicySelectionsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingCustodyAccountVotingPolicySelectionsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DirectvotingCustodyAccountVotingPolicySelectionsDestroyResponses,
    DirectvotingCustodyAccountVotingPolicySelectionsDestroyErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/custody-account-voting-policy-selections/{identity_id}/',
    ...options,
  })

/**
 * Get a custody account voting policy selection
 *
 * Returns the current version of the selection addressed by its identity id.
 */
export const directvotingCustodyAccountVotingPolicySelectionsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingCustodyAccountVotingPolicySelectionsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DirectvotingCustodyAccountVotingPolicySelectionsRetrieveResponses,
    DirectvotingCustodyAccountVotingPolicySelectionsRetrieveErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingCustodyAccountVotingPolicySelectionsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/custody-account-voting-policy-selections/{identity_id}/',
    ...options,
  })

/**
 * Partially update a custody account voting policy selection
 *
 * Appends a new version with the supplied fields applied over the current one and closes the previous version. The custody account identifies the selection and cannot be changed; a different value is ignored. An unchanged write creates no new version.
 */
export const directvotingCustodyAccountVotingPolicySelectionsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingCustodyAccountVotingPolicySelectionsPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    DirectvotingCustodyAccountVotingPolicySelectionsPartialUpdateResponses,
    DirectvotingCustodyAccountVotingPolicySelectionsPartialUpdateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingCustodyAccountVotingPolicySelectionsPartialUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/custody-account-voting-policy-selections/{identity_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Update a custody account voting policy selection
 *
 * Appends a new version carrying the supplied values and closes the previous one. The custody account identifies the selection and cannot be changed; a different value is ignored. An unchanged write creates no new version.
 */
export const directvotingCustodyAccountVotingPolicySelectionsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingCustodyAccountVotingPolicySelectionsUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<
    DirectvotingCustodyAccountVotingPolicySelectionsUpdateResponses,
    DirectvotingCustodyAccountVotingPolicySelectionsUpdateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingCustodyAccountVotingPolicySelectionsUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/custody-account-voting-policy-selections/{identity_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search custody account voting policy selections
 *
 * Lists the current version of every custody account voting policy selection that is not deleted. Filters (voter_id, custody_account_id, voting_policy_id) travel in the request body and combine with AND; pagination uses the `cursor` and `page_size` query parameters.
 */
export const directvotingCustodyAccountVotingPolicySelectionsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<DirectvotingCustodyAccountVotingPolicySelectionsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    DirectvotingCustodyAccountVotingPolicySelectionsSearchCreateResponses,
    DirectvotingCustodyAccountVotingPolicySelectionsSearchCreateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingCustodyAccountVotingPolicySelectionsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/custody-account-voting-policy-selections/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * List custody accounts
 */
export const directvotingCustodyAccountsList = <ThrowOnError extends boolean = false>(
  options?: Options<DirectvotingCustodyAccountsListData, ThrowOnError>
) =>
  (options?.client ?? client).get<
    DirectvotingCustodyAccountsListResponses,
    DirectvotingCustodyAccountsListErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingCustodyAccountsListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/custody-accounts/',
    ...options,
  })

/**
 * Create a custody account
 */
export const directvotingCustodyAccountsCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingCustodyAccountsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectvotingCustodyAccountsCreateResponses,
    DirectvotingCustodyAccountsCreateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingCustodyAccountsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/custody-accounts/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a custody account
 */
export const directvotingCustodyAccountsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingCustodyAccountsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    DirectvotingCustodyAccountsDestroyResponses,
    DirectvotingCustodyAccountsDestroyErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/custody-accounts/{id}/',
    ...options,
  })

/**
 * Get a custody account
 */
export const directvotingCustodyAccountsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingCustodyAccountsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DirectvotingCustodyAccountsRetrieveResponses,
    DirectvotingCustodyAccountsRetrieveErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingCustodyAccountsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/custody-accounts/{id}/',
    ...options,
  })

/**
 * Partially update a custody account
 */
export const directvotingCustodyAccountsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingCustodyAccountsPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    DirectvotingCustodyAccountsPartialUpdateResponses,
    DirectvotingCustodyAccountsPartialUpdateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingCustodyAccountsPartialUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/custody-accounts/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Update a custody account
 */
export const directvotingCustodyAccountsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingCustodyAccountsUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<
    DirectvotingCustodyAccountsUpdateResponses,
    DirectvotingCustodyAccountsUpdateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingCustodyAccountsUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/custody-accounts/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List voters
 */
export const directvotingVotersList = <ThrowOnError extends boolean = false>(
  options?: Options<DirectvotingVotersListData, ThrowOnError>
) =>
  (options?.client ?? client).get<DirectvotingVotersListResponses, unknown, ThrowOnError>({
    responseTransformer: directvotingVotersListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/voters/',
    ...options,
  })

/**
 * Create a voter
 */
export const directvotingVotersCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingVotersCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<DirectvotingVotersCreateResponses, unknown, ThrowOnError>({
    responseTransformer: directvotingVotersCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/voters/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a voter
 */
export const directvotingVotersDestroy = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingVotersDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<DirectvotingVotersDestroyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/voters/{id}/',
    ...options,
  })

/**
 * Get a voter
 */
export const directvotingVotersRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingVotersRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<DirectvotingVotersRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: directvotingVotersRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/voters/{id}/',
    ...options,
  })

/**
 * Partially update a voter
 */
export const directvotingVotersPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingVotersPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<DirectvotingVotersPartialUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: directvotingVotersPartialUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/voters/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Update a voter
 */
export const directvotingVotersUpdate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingVotersUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<DirectvotingVotersUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: directvotingVotersUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/voters/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Cast a voter's votes on a ballot
 *
 * Record how a voter instructs every proposal on one of their ballots. The ballot is resolved via the voter's qualifying ballots, so a ballot the voter cannot vote on returns 404. The submitted proposals must cover the ballot's proposal set exactly - a missing, unknown or repeated proposal is rejected - and each response must be one of that proposal's own voting options. Votes are refused once the ballot's vote deadline has passed, or when its meeting is cancelled or past its submission deadline. A re-cast that changes anything appends a new version for every proposal in the ballot's proposal set under a new instruction set id, and a re-cast that changes nothing writes nothing. Two casts racing on the same ballot are resolved by returning 409 Conflict to the loser. Instructions are returned in the ballot's proposal order.
 */
export const directvotingVotersBallotsCastVoteCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingVotersBallotsCastVoteCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectvotingVotersBallotsCastVoteCreateResponses,
    DirectvotingVotersBallotsCastVoteCreateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingVotersBallotsCastVoteCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/voters/{voter_id}/ballots/{ballot_id}/cast-vote/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List a ballot's proposals
 *
 * List the proxy intermediary proposals on one of a voter's ballots, resolved through the ballot's linked proposal set. The ballot is resolved via the voter's qualifying ballots, so a ballot the voter cannot vote on returns 404. Proposals are ordered by sequence number ascending (nulls last), then id. Each proposal carries the voter's current instruction on it for this ballot, or null when it has not been instructed. Returns an empty list when the ballot has no linked proposal set.
 */
export const directvotingVotersBallotsProposalsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingVotersBallotsProposalsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    DirectvotingVotersBallotsProposalsRetrieveResponses,
    DirectvotingVotersBallotsProposalsRetrieveErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingVotersBallotsProposalsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/voters/{voter_id}/ballots/{ballot_id}/proposals/',
    ...options,
  })

/**
 * Search a voter's ballots
 *
 * List the proxy intermediary ballots a voter can vote on, resolved through the voter's linked custody accounts. Only current, non-cancelled ballots are returned. Filters travel in the request body; pagination uses the `cursor` and `page_size` query parameters. An optional proxy_intermediary_meeting_id restricts the result to a single meeting.
 */
export const directvotingVotersBallotsSearchCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingVotersBallotsSearchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectvotingVotersBallotsSearchCreateResponses,
    DirectvotingVotersBallotsSearchCreateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingVotersBallotsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/voters/{voter_id}/ballots/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search a voter's proxy intermediary meetings
 *
 * List the proxy intermediary meetings a voter can vote on, resolved through the voter's linked custody accounts. Only current, non-cancelled meeting versions are returned, each once. Filters (search, proxy_intermediary_meeting_ids, deadline bounds) travel in the request body and combine with AND; ordering defaults to meeting deadline ascending. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const directvotingVotersMeetingsSearchCreate = <ThrowOnError extends boolean = false>(
  options: Options<DirectvotingVotersMeetingsSearchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    DirectvotingVotersMeetingsSearchCreateResponses,
    DirectvotingVotersMeetingsSearchCreateErrors,
    ThrowOnError
  >({
    responseTransformer: directvotingVotersMeetingsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/directvoting/voters/{voter_id}/meetings/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create a fund manager
 */
export const fundManagerFundManagersCreate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundManagersCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<FundManagerFundManagersCreateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundManagersCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/fund-managers/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Fetch a fund manager's policies
 *
 * Returns all policy PDFs for a fund manager, each with a 24-hour presigned URL. The list is not paginated. Returns 404 if the fund manager does not exist.
 */
export const fundManagerFundManagersPoliciesRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundManagersPoliciesRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<FundManagerFundManagersPoliciesRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundManagersPoliciesRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/fund-managers/{fund_manager_id}/policies/',
    ...options,
  })

/**
 * Upload a fund manager policy
 *
 * Uploads a policy PDF for a fund manager. The request body must be the raw PDF file with Content-Type: application/pdf, and the filename query parameter becomes the policy title (without the '.pdf' extension). The file must be smaller than 10,000,000 bytes. Returns 404 if the fund manager does not exist, and 400 for a non-'.pdf' filename or an oversized body.
 */
export const fundManagerFundManagersPoliciesCreate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundManagersPoliciesCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<FundManagerFundManagersPoliciesCreateResponses, unknown, ThrowOnError>({
    bodySerializer: null,
    responseTransformer: fundManagerFundManagersPoliciesCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/fund-managers/{fund_manager_id}/policies/',
    ...options,
    headers: {
      'Content-Type': 'application/pdf',
      ...options.headers,
    },
  })

/**
 * Get a fund manager
 */
export const fundManagerFundManagersRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundManagersRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<FundManagerFundManagersRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundManagersRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/fund-managers/{id}/',
    ...options,
  })

/**
 * Update a fund manager
 */
export const fundManagerFundManagersUpdate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundManagersUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<FundManagerFundManagersUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundManagersUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/fund-managers/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search fund managers
 *
 * Search fund managers with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. names, relationship_owners) are sent in the body to avoid overflowing URL-length limits. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const fundManagerFundManagersSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<FundManagerFundManagersSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<FundManagerFundManagersSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundManagersSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/fund-managers/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Create a fund variant
 *
 * Creates a fund variant under the given parent fund. Public security IDs that don't yet exist are created automatically; custom security IDs must already exist. The fund variant must reference at least one public or custom security ID, and cash security IDs are rejected.
 */
export const fundManagerFundVariantsCreate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundVariantsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<FundManagerFundVariantsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundVariantsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/fund-variants/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a fund variant
 *
 * Deletes a fund variant, unlinking any security IDs that reference it.
 */
export const fundManagerFundVariantsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundVariantsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<FundManagerFundVariantsDestroyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/fund-variants/{id}/',
    ...options,
  })

/**
 * Get a fund variant
 *
 * Returns a single fund variant by its id.
 */
export const fundManagerFundVariantsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundVariantsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<FundManagerFundVariantsRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundVariantsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/fund-variants/{id}/',
    ...options,
  })

/**
 * Update a fund variant
 *
 * Updates a fund variant's title, cfi and linked security IDs. Supplying a different `fund_name` reparents the variant onto that fund. Security IDs already linked to another variant are rejected with 409.
 */
export const fundManagerFundVariantsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundVariantsUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<FundManagerFundVariantsUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundVariantsUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/fund-variants/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search fund variants
 *
 * Search fund variants with filters supplied in the request body. The parent fund filter is optional: omit `fund_name` to search across all funds (the wildcard parent 'funds/-'). Results are ordered by fund id, title, id. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const fundManagerFundVariantsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<FundManagerFundVariantsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<FundManagerFundVariantsSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundVariantsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/fund-variants/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Create a fund
 *
 * Creates a fund, including any proxy intermediary account identifiers supplied with it.
 */
export const fundManagerFundsCreate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<FundManagerFundsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/funds/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create a fund quantification snapshot
 *
 * Creates an immutable fund quantification snapshot under the given fund, including the quantifications of the fund's variants supplied with it.
 */
export const fundManagerFundsQuantificationSnapshotsCreate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundsQuantificationSnapshotsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<FundManagerFundsQuantificationSnapshotsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundsQuantificationSnapshotsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/funds/{fund_id}/quantification-snapshots/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get a fund
 *
 * Returns a fund. When the optional `product` query parameter is supplied, the fund is only returned if it belongs to that product; otherwise a 404 is returned.
 */
export const fundManagerFundsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<FundManagerFundsRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/funds/{id}/',
    ...options,
  })

/**
 * Update a fund
 *
 * Updates a fund. The product and fund manager of a fund cannot be changed. When proxy intermediary identifiers are supplied, the fund's proxy intermediary accounts are synced to match them; when omitted (or null), existing accounts are left untouched.
 */
export const fundManagerFundsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundsUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<FundManagerFundsUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundsUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/funds/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search funds
 *
 * Search funds with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. names, external_ids, account ids) are sent in the body to avoid overflowing URL-length limits. Results are ordered by create time descending, id descending. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const fundManagerFundsSearchCreate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerFundsSearchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<FundManagerFundsSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerFundsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/funds/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List providers
 */
export const fundManagerProvidersList = <ThrowOnError extends boolean = false>(
  options?: Options<FundManagerProvidersListData, ThrowOnError>
) =>
  (options?.client ?? client).get<FundManagerProvidersListResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerProvidersListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/providers/',
    ...options,
  })

/**
 * Create a provider
 */
export const fundManagerProvidersCreate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerProvidersCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<FundManagerProvidersCreateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerProvidersCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/providers/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get a provider
 */
export const fundManagerProvidersRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerProvidersRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<FundManagerProvidersRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerProvidersRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/providers/{id}/',
    ...options,
  })

/**
 * Update a provider
 */
export const fundManagerProvidersUpdate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerProvidersUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<FundManagerProvidersUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerProvidersUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/providers/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search fund quantification snapshots
 *
 * Search fund quantification snapshots with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. names, fund_names) are sent in the body to avoid overflowing URL-length limits. Results are ordered by valid time descending, id descending. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const fundManagerQuantificationSnapshotsSearchCreate = <ThrowOnError extends boolean = false>(
  options: Options<FundManagerQuantificationSnapshotsSearchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<FundManagerQuantificationSnapshotsSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: fundManagerQuantificationSnapshotsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/fund-manager/quantification-snapshots/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List meetings with filtering and cursor pagination.
 */
export const institutionalMeetingsearchList = <ThrowOnError extends boolean = false>(
  options: Options<InstitutionalMeetingsearchListData, ThrowOnError>
) =>
  (options.client ?? client).get<InstitutionalMeetingsearchListResponses, unknown, ThrowOnError>({
    responseTransformer: institutionalMeetingsearchListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/institutional/meetingsearch',
    ...options,
  })

/**
 * List ballot versions
 *
 * Return every version of the ballot identity, most recently written version first. Each version carries its own deadlines where they exist. Returns 404 if the ballot does not exist. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const proxyIntermediaryBallotsVersionsList = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryBallotsVersionsListData, ThrowOnError>
) =>
  (options.client ?? client).get<ProxyIntermediaryBallotsVersionsListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyIntermediaryBallotsVersionsListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/ballots/{ballot_id}/versions/',
    ...options,
  })

/**
 * Fetch ballots by version ids
 *
 * Return ballots by their version ids. Unknown version ids are silently ignored.
 */
export const proxyIntermediaryBallotsFetchByVersionIdsCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryBallotsFetchByVersionIdsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyIntermediaryBallotsFetchByVersionIdsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyIntermediaryBallotsFetchByVersionIdsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/ballots/fetch-by-version-ids/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search ballots
 *
 * List proxy intermediary ballots matching the supplied filters. Filters travel in the request body to avoid overflowing URL-length limits on unbounded collections; pagination uses the `cursor` and `page_size` query parameters. Absent or empty filters return all current ballots.
 */
export const proxyIntermediaryBallotsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyIntermediaryBallotsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<ProxyIntermediaryBallotsSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyIntermediaryBallotsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/ballots/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Upsert a ballot
 *
 * Create or update a proxy intermediary ballot. The ballot is versioned bi-temporally: the latest visible ballot is the one with the most recent valid_time, and an upsert with no content changes returns STATUS_BALLOT_NO_OPERATION. Returns 404 if the proxy intermediary meeting does not exist and 400 if the request is invalid. Every upsert publishes a ballot event once the write has committed; a failure to publish returns 500 even though the write succeeded, so callers must be able to retry the same upsert.
 */
export const proxyIntermediaryBallotsUpsertCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryBallotsUpsertCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyIntermediaryBallotsUpsertCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyIntermediaryBallotsUpsertCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/ballots/upsert/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Assign a category to a proposal
 *
 * Assigns a proxy intermediary's free-text category to a transparency proposal, creating the category if none exists for the (proxy intermediary, proposal) pair or updating it otherwise.
 */
export const proxyIntermediaryProposalCategoriesAssignCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryProposalCategoriesAssignCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyIntermediaryProposalCategoriesAssignCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proposal-categories/assign/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List categories for proposals
 *
 * Lists the proposal categories matching the given proxy intermediaries and transparency proposals. Filters are sent in the request body to avoid overflowing URL-length limits.
 */
export const proxyIntermediaryProposalCategoriesListCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryProposalCategoriesListCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyIntermediaryProposalCategoriesListCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proposal-categories/list/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Assign a label to a proposal
 *
 * Assigns a proxy intermediary's label to a transparency proposal. An empty label deletes any existing label for the proposal; a non-empty label creates or updates it. The label must be unique per (proxy intermediary, transparency general meeting) pair.
 */
export const proxyIntermediaryProposalLabelsAssignCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryProposalLabelsAssignCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyIntermediaryProposalLabelsAssignCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proposal-labels/assign/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Fetch labels for proposals
 *
 * Fetches the labels and categories for the given transparency proposals and proxy intermediary. Proposals without a label are omitted from the response maps. Proposal names are sent in the request body to avoid overflowing URL-length limits.
 */
export const proxyIntermediaryProposalLabelsFetchCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryProposalLabelsFetchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyIntermediaryProposalLabelsFetchCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proposal-labels/fetch/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create a proxy intermediary proposal set
 *
 * Create a set of proxy intermediary proposals atomically. The set is identified by a SHA-256 hash of its proposals; all proposals must belong to the same meeting. Returns 409 when a set with the same hash already exists.
 */
export const proxyIntermediaryProposalsCreateCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryProposalsCreateCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyIntermediaryProposalsCreateCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyIntermediaryProposalsCreateCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proposals/create/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a proxy intermediary proposal set
 *
 * Delete every proposal in the set identified by `proposal_set_id`. All proposals in the set are removed atomically. Returns 404 when no proposals exist for the set.
 */
export const proxyIntermediaryProposalsDeleteCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryProposalsDeleteCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyIntermediaryProposalsDeleteCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proposals/delete/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search proxy intermediary proposals
 *
 * Search proxy intermediary proposals with filters supplied in the request body. When multiple filters are present they are combined with AND. Results are ordered by creation time. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const proxyIntermediaryProposalsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyIntermediaryProposalsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<ProxyIntermediaryProposalsSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyIntermediaryProposalsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proposals/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Search proxy intermediaries
 *
 * Search proxy intermediaries with filters supplied in the request body. Filters that may contain large, unbounded collections (names, titles) are sent in the body to avoid overflowing URL-length limits. Absent or empty filters return all proxy intermediaries. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const proxyIntermediaryProxyIntermediariesSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyIntermediaryProxyIntermediariesSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<ProxyIntermediaryProxyIntermediariesSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyIntermediaryProxyIntermediariesSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proxy-intermediaries/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Search proxy intermediary meeting audit events
 *
 * Search audit events for proxy intermediary meetings. Either `audit_event_names` or `entity_name` must be supplied. Results are ordered by creation time descending. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const proxyIntermediaryProxyIntermediaryMeetingsAuditEventsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyIntermediaryProxyIntermediaryMeetingsAuditEventsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    ProxyIntermediaryProxyIntermediaryMeetingsAuditEventsSearchCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: proxyIntermediaryProxyIntermediaryMeetingsAuditEventsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proxy-intermediary-meetings/audit-events/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Cancel proxy intermediary meetings
 *
 * Cancel a batch of meetings by resource name. Every named meeting must have a current, non-cancelled version, otherwise the whole batch is rejected.
 */
export const proxyIntermediaryProxyIntermediaryMeetingsCancelCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryProxyIntermediaryMeetingsCancelCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ProxyIntermediaryProxyIntermediaryMeetingsCancelCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: proxyIntermediaryProxyIntermediaryMeetingsCancelCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proxy-intermediary-meetings/cancel/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Link a meeting to a transparency general meeting
 *
 * Set the transparency general meeting a proxy intermediary meeting is linked to. The transparency general meeting must exist. Recomputes ballot deadlines for the meeting.
 */
export const proxyIntermediaryProxyIntermediaryMeetingsLinkTransparencyGeneralMeetingCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProxyIntermediaryProxyIntermediaryMeetingsLinkTransparencyGeneralMeetingCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ProxyIntermediaryProxyIntermediaryMeetingsLinkTransparencyGeneralMeetingCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer:
      proxyIntermediaryProxyIntermediaryMeetingsLinkTransparencyGeneralMeetingCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proxy-intermediary-meetings/link-transparency-general-meeting/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search proxy intermediary meetings
 *
 * Search the current version of proxy intermediary meetings with filters supplied in the request body. Filters that may contain large collections are sent in the body to avoid overflowing URL-length limits. Results are ordered by submission deadline. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const proxyIntermediaryProxyIntermediaryMeetingsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyIntermediaryProxyIntermediaryMeetingsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    ProxyIntermediaryProxyIntermediaryMeetingsSearchCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: proxyIntermediaryProxyIntermediaryMeetingsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proxy-intermediary-meetings/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Unlink a meeting from its transparency general meeting
 *
 * Clear the transparency general meeting a proxy intermediary meeting is linked to.
 */
export const proxyIntermediaryProxyIntermediaryMeetingsUnlinkTransparencyGeneralMeetingCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProxyIntermediaryProxyIntermediaryMeetingsUnlinkTransparencyGeneralMeetingCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ProxyIntermediaryProxyIntermediaryMeetingsUnlinkTransparencyGeneralMeetingCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer:
      proxyIntermediaryProxyIntermediaryMeetingsUnlinkTransparencyGeneralMeetingCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proxy-intermediary-meetings/unlink-transparency-general-meeting/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Upsert a proxy intermediary meeting
 *
 * Create a meeting, or update the current version of an existing one identified by its proxy intermediary and external id. An empty update mask updates all patchable fields. Returns the resulting meeting and whether it was created, updated, or left unchanged.
 */
export const proxyIntermediaryProxyIntermediaryMeetingsUpsertCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryProxyIntermediaryMeetingsUpsertCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ProxyIntermediaryProxyIntermediaryMeetingsUpsertCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: proxyIntermediaryProxyIntermediaryMeetingsUpsertCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proxy-intermediary-meetings/upsert/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create a Proxymity vote
 *
 * Record a fund manager's vote instruction submitted through Proxymity. Instructions are appended rather than updated: the current instruction for a single instruction id is the one with the most recent valid_time. Returns 400 if the request is invalid, which includes the vote directions for an agenda resolution summing to more than the instructed balance.
 */
export const proxyIntermediaryProxymityVotesCreateCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryProxymityVotesCreateCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyIntermediaryProxymityVotesCreateCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyIntermediaryProxymityVotesCreateCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proxymity-votes/create/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Fetch the latest Proxymity vote
 *
 * Return the vote instruction with the most recent valid_time for a single instruction id. Returns 400 if the request is invalid, and 404 if no instruction carries this single instruction id.
 */
export const proxyIntermediaryProxymityVotesFetchLatestCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryProxymityVotesFetchLatestCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyIntermediaryProxymityVotesFetchLatestCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyIntermediaryProxymityVotesFetchLatestCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/proxymity-votes/fetch-latest/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a vote status
 *
 * Retract a vote status so it is no longer visible, by setting its delete time. Retracting an already-retracted status keeps the original delete time. Returns 400 if the id is malformed and 404 if no vote status has this id.
 */
export const proxyIntermediaryVoteStatusesDeleteCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryVoteStatusesDeleteCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyIntermediaryVoteStatusesDeleteCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/vote-statuses/delete/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Upsert a vote status
 *
 * Record the status a proxy intermediary reports for a ballot's votes. Statuses are appended rather than updated: the visible status is the one with the most recent valid_time, and an upsert whose vote_status and status_note are unchanged returns STATUS_VOTE_STATUS_NO_OPERATION without writing. Returns 400 if the request is invalid, 422 if the proxy intermediary does not exist, and 409 if the status collides with one already recorded.
 */
export const proxyIntermediaryVoteStatusesUpsertCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyIntermediaryVoteStatusesUpsertCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyIntermediaryVoteStatusesUpsertCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyIntermediaryVoteStatusesUpsertCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxy-intermediary/vote-statuses/upsert/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List ballot entitlements
 *
 * Returns ballot entitlements, optionally filtered by proxy_intermediary_ballot_id or investor_account_id. By default, only active entitlements (invalid_time is null) are returned. Set include_invalid=true to include invalidated entitlements.
 */
export const proxyvotingEntitlementsList = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyvotingEntitlementsListData, ThrowOnError>
) =>
  (options?.client ?? client).get<ProxyvotingEntitlementsListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingEntitlementsListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/entitlements',
    ...options,
  })

/**
 * Compute ballot breakdown synchronously
 *
 * Computes the ballot breakdown for a proxy intermediary ballot with specified filters. Returns the full graph structure in JSON format. This is a synchronous operation.
 */
export const proxyvotingEntitlementsBreakdownCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingEntitlementsBreakdownCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyvotingEntitlementsBreakdownCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/entitlements/breakdown',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Trigger entitlements computation
 *
 * Enqueues an entitlements computation task to run asynchronously. Returns task_id to check status
 */
export const proxyvotingEntitlementsComputeCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingEntitlementsComputeCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyvotingEntitlementsComputeCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/entitlements:compute',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Update Fund Manager Supported Issued Instruments
 *
 * Updates a fund manager's Supported Issued Instruments for the given voting policies and ISINs. Adds new instruments and invalidates existing instruments not in the provided list.
 */
export const proxyvotingFundManagerCompositionsSiiFromCompositionDifferenceCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProxyvotingFundManagerCompositionsSiiFromCompositionDifferenceCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ProxyvotingFundManagerCompositionsSiiFromCompositionDifferenceCreateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/fund-manager/compositions/sii/from-composition-difference',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Batch create fund manager policy supported issued instruments
 *
 * Creates fund manager policy supported issued instruments for the given fund manager and voting policy. Instruments that already exist are silently ignored (no-op).
 */
export const proxyvotingFundManagerPolicySupportedIssuedInstrumentsCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ProxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: proxyvotingFundManagerPolicySupportedIssuedInstrumentsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/fund-manager/policy-supported-issued-instruments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Batch delete fund manager policy supported issued instruments
 *
 * Soft-deletes fund manager policy supported issued instruments by name (sets delete_time and valid_to).
 */
export const proxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ProxyvotingFundManagerPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/fund-manager/policy-supported-issued-instruments/batch-delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search fund manager policy supported issued instruments
 *
 * Search fund manager policy supported issued instruments with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. fund_manager_names, voting_policy_names, public_security_id_names) are sent in the body to avoid overflowing URL-length limits. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const proxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreate = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<ProxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    ProxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: proxyvotingFundManagerPolicySupportedIssuedInstrumentsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/fund-manager/policy-supported-issued-instruments/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * List fund manager supported policies
 *
 * Returns all fund manager / voting policy links, optionally filtered. Supply as_of to fetch the historical state at a specific point in time.
 */
export const proxyvotingFundManagerSupportedPoliciesList = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyvotingFundManagerSupportedPoliciesListData, ThrowOnError>
) =>
  (options?.client ?? client).get<ProxyvotingFundManagerSupportedPoliciesListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingFundManagerSupportedPoliciesListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/fund-manager/supported-policies',
    ...options,
  })

/**
 * Batch upsert fund manager supported policies
 *
 * Creates or ensures existence of fund manager / voting policy links. All upserts are applied atomically.
 */
export const proxyvotingFundManagerSupportedPoliciesCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingFundManagerSupportedPoliciesCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyvotingFundManagerSupportedPoliciesCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingFundManagerSupportedPoliciesCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/fund-manager/supported-policies',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a fund manager supported policy
 *
 * Deletes the fund manager / voting policy link with the given ID.
 */
export const proxyvotingFundManagerSupportedPoliciesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingFundManagerSupportedPoliciesDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<ProxyvotingFundManagerSupportedPoliciesDestroyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/fund-manager/supported-policies/{id}',
    ...options,
  })

/**
 * Get composition differences
 *
 * Fetches and compares investor compositions between two time periods
 */
export const proxyvotingInvestorCompositionsDifferenceList = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingInvestorCompositionsDifferenceListData, ThrowOnError>
) =>
  (options.client ?? client).get<ProxyvotingInvestorCompositionsDifferenceListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingInvestorCompositionsDifferenceListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/compositions/difference',
    ...options,
  })

export const proxyvotingInvestorCompositionsRenderCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingInvestorCompositionsRenderCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyvotingInvestorCompositionsRenderCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/compositions/render',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get investor rules engine mapping
 *
 * Retrieves the rules engine mapping for a specific investor. Requires vops.administrator role.
 */
export const proxyvotingInvestorCompositionsRulesEngineRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingInvestorCompositionsRulesEngineRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<ProxyvotingInvestorCompositionsRulesEngineRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingInvestorCompositionsRulesEngineRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/compositions/rules-engine',
    ...options,
  })

/**
 * Map investor to rules engine
 *
 * Upserts mapping between an investor and their voting rules engine. Returns 201 for new mappings, 200 for updates. Requires vops.administrator role.
 */
export const proxyvotingInvestorCompositionsRulesEngineUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingInvestorCompositionsRulesEngineUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<ProxyvotingInvestorCompositionsRulesEngineUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingInvestorCompositionsRulesEngineUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/compositions/rules-engine',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Update Supported Issued Instruments from composition difference
 *
 * Updates an investor's Supported Issued Instruments based on a provided composition difference. Adds new instruments and invalidates removed instruments.
 */
export const proxyvotingInvestorCompositionsSiiFromCompositionDifferenceCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingInvestorCompositionsSiiFromCompositionDifferenceCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ProxyvotingInvestorCompositionsSiiFromCompositionDifferenceCreateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/compositions/sii/from-composition-difference',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Batch create investor policy supported issued instruments
 *
 * Creates investor policy supported issued instruments for the given investor and voting policy. Instruments that already exist are silently ignored (no-op).
 */
export const proxyvotingInvestorPolicySupportedIssuedInstrumentsCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ProxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: proxyvotingInvestorPolicySupportedIssuedInstrumentsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/policy-supported-issued-instruments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Batch delete investor policy supported issued instruments
 *
 * Soft-deletes investor policy supported issued instruments by name (sets delete_time and valid_to).
 */
export const proxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ProxyvotingInvestorPolicySupportedIssuedInstrumentsBatchDeleteCreateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/policy-supported-issued-instruments/batch-delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search investor policy supported issued instruments
 *
 * Search investor policy supported issued instruments with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. investor_names, voting_policy_names, public_security_id_names) are sent in the body to avoid overflowing URL-length limits. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const proxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    ProxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: proxyvotingInvestorPolicySupportedIssuedInstrumentsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/policy-supported-issued-instruments/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Batch create investor supported issued instruments
 *
 * Creates investor supported issued instruments for the given investor. Instruments that already exist are silently ignored (no-op).
 */
export const proxyvotingInvestorSupportedIssuedInstrumentsCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingInvestorSupportedIssuedInstrumentsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyvotingInvestorSupportedIssuedInstrumentsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingInvestorSupportedIssuedInstrumentsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/supported-issued-instruments',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Batch delete investor supported issued instruments
 *
 * Soft-deletes investor supported issued instruments by name (sets delete_time and valid_to).
 */
export const proxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    ProxyvotingInvestorSupportedIssuedInstrumentsBatchDeleteCreateResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/supported-issued-instruments/batch-delete',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search investor supported issued instruments
 *
 * Search investor supported issued instruments with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. investor_names, public_security_id_names) are sent in the body to avoid overflowing URL-length limits. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const proxyvotingInvestorSupportedIssuedInstrumentsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyvotingInvestorSupportedIssuedInstrumentsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    ProxyvotingInvestorSupportedIssuedInstrumentsSearchCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: proxyvotingInvestorSupportedIssuedInstrumentsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/investor/supported-issued-instruments/search',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * List meeting ballot sources
 *
 * Returns meeting ballot sources, optionally filtered by meeting_ballot_id or proxy_intermediary_ballot_id. By default, only active sources (invalid_time is null) are returned. Set include_invalid=true to include invalidated sources.
 */
export const proxyvotingMeetingBallotSourcesList = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyvotingMeetingBallotSourcesListData, ThrowOnError>
) =>
  (options?.client ?? client).get<ProxyvotingMeetingBallotSourcesListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingMeetingBallotSourcesListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/meeting-ballot-sources',
    ...options,
  })

/**
 * List meeting ballots
 *
 * Returns meeting ballots, optionally filtered by investor_id or general_meeting_id.
 */
export const proxyvotingMeetingBallotsList = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyvotingMeetingBallotsListData, ThrowOnError>
) =>
  (options?.client ?? client).get<ProxyvotingMeetingBallotsListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingMeetingBallotsListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/meeting-ballots',
    ...options,
  })

/**
 * Trigger meeting ballot handout processing
 *
 * Enqueues a meeting ballot handout task to run asynchronously. Returns task_id to check status
 */
export const proxyvotingMeetingballotsComputeCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingMeetingballotsComputeCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyvotingMeetingballotsComputeCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/meetingballots:compute',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Filter proxy intermediary ballot search results with cursor-based pagination.
 */
export const proxyvotingPiballotsFilterList = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyvotingPiballotsFilterListData, ThrowOnError>
) =>
  (options?.client ?? client).get<ProxyvotingPiballotsFilterListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingPiballotsFilterListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/piballots/filter',
    ...options,
  })

/**
 * Compute investor accounts who can vote on ballots, and whether investigation is required the ballot
 *
 * For each provided ballot ID, returns the number of investor accounts expected to vote, their individual fund proportions, and whether the ballot requires investigation due to potentially missing or inaccurate entitlements data.
 */
export const proxyvotingPiballotsInvestorsCanVoteCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingPiballotsInvestorsCanVoteCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyvotingPiballotsInvestorsCanVoteCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/piballots/investors-can-vote',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Filter proxy intermediary meeting search results with cursor-based pagination. Returns meetings that are in scope for voting operations workflow, along with their scope information.
 */
export const proxyvotingPimeetingsFilterList = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyvotingPimeetingsFilterListData, ThrowOnError>
) =>
  (options?.client ?? client).get<ProxyvotingPimeetingsFilterListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingPimeetingsFilterListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/pimeetings/filter',
    ...options,
  })

/**
 * List rules engine definitions
 *
 * Returns all rules engine definition versions, optionally filtered by name.
 */
export const proxyvotingRulesEngineDefinitionsList = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyvotingRulesEngineDefinitionsListData, ThrowOnError>
) =>
  (options?.client ?? client).get<ProxyvotingRulesEngineDefinitionsListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingRulesEngineDefinitionsListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions',
    ...options,
  })

/**
 * Create a rules engine definition
 *
 * Creates a new rules engine definition version.
 */
export const proxyvotingRulesEngineDefinitionsCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingRulesEngineDefinitionsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyvotingRulesEngineDefinitionsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingRulesEngineDefinitionsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List rules for a definition
 *
 * Returns all rules for the given rules engine definition, ordered by rule order.
 */
export const proxyvotingRulesEngineDefinitionsRulesList = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingRulesEngineDefinitionsRulesListData, ThrowOnError>
) =>
  (options.client ?? client).get<ProxyvotingRulesEngineDefinitionsRulesListResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingRulesEngineDefinitionsRulesListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions/{definition_id}/rules',
    ...options,
  })

/**
 * Create a rule
 *
 * Creates a new rule within the given rules engine definition.
 */
export const proxyvotingRulesEngineDefinitionsRulesCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingRulesEngineDefinitionsRulesCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyvotingRulesEngineDefinitionsRulesCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingRulesEngineDefinitionsRulesCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions/{definition_id}/rules',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a rule
 *
 * Deletes the rule with the given ID within the given definition.
 */
export const proxyvotingRulesEngineDefinitionsRulesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingRulesEngineDefinitionsRulesDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<ProxyvotingRulesEngineDefinitionsRulesDestroyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions/{definition_id}/rules/{id}',
    ...options,
  })

/**
 * Update a rule
 *
 * Replaces all fields of the rule with the given ID within the given definition.
 */
export const proxyvotingRulesEngineDefinitionsRulesUpdate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingRulesEngineDefinitionsRulesUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<ProxyvotingRulesEngineDefinitionsRulesUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingRulesEngineDefinitionsRulesUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions/{definition_id}/rules/{id}',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a rules engine definition
 *
 * Deletes the definition with the given ID and its associated rules. Returns 409 if this is the last definition for its name — use DELETE /rules-engine-definitions/by-name/{name} to delete the engine entirely.
 */
export const proxyvotingRulesEngineDefinitionsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingRulesEngineDefinitionsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ProxyvotingRulesEngineDefinitionsDestroyResponses,
    ProxyvotingRulesEngineDefinitionsDestroyErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions/{id}',
    ...options,
  })

/**
 * Retrieve a rules engine definition
 *
 * Returns the rules engine definition with the given ID.
 */
export const proxyvotingRulesEngineDefinitionsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingRulesEngineDefinitionsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<ProxyvotingRulesEngineDefinitionsRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingRulesEngineDefinitionsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions/{id}',
    ...options,
  })

/**
 * Delete all definitions for a name
 *
 * Deletes all versioned definitions with the given name and their associated rules. Returns 409 if the name is the Tumelo base engine or if any investor is configured to use this rules engine. Returns 404 if no definitions exist with the given name.
 */
export const proxyvotingRulesEngineDefinitionsByNameDestroy = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingRulesEngineDefinitionsByNameDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    ProxyvotingRulesEngineDefinitionsByNameDestroyResponses,
    ProxyvotingRulesEngineDefinitionsByNameDestroyErrors,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions/by-name/{name}',
    ...options,
  })

/**
 * List rules engine names
 *
 * Returns the distinct names of all rules engines, sorted alphabetically. Use this to render a list of available rules engines before fetching their versions.
 */
export const proxyvotingRulesEngineDefinitionsNamesRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyvotingRulesEngineDefinitionsNamesRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<ProxyvotingRulesEngineDefinitionsNamesRetrieveResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/rules-engine-definitions/names',
    ...options,
  })

/**
 * Create a new Split Vote Instruction Proposal Overwrite.
 */
export const proxyvotingSviProposalOverwriteCreate = <ThrowOnError extends boolean = false>(
  options: Options<ProxyvotingSviProposalOverwriteCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<ProxyvotingSviProposalOverwriteCreateResponses, unknown, ThrowOnError>({
    responseTransformer: proxyvotingSviProposalOverwriteCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/svi/proposal/overwrite',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Retrieve a list of Split Vote Instruction Overwrite Reasons.
 */
export const proxyvotingSviProposalOverwriteReasonsList = <ThrowOnError extends boolean = false>(
  options?: Options<ProxyvotingSviProposalOverwriteReasonsListData, ThrowOnError>
) =>
  (options?.client ?? client).get<ProxyvotingSviProposalOverwriteReasonsListResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/proxyvoting/svi/proposal/overwrite/reasons',
    ...options,
  })

/**
 * Search audit events
 *
 * Search audit events with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. audit_event_names) are sent in the body to avoid overflowing URL-length limits. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const transparencyAuditEventsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<TransparencyAuditEventsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<TransparencyAuditEventsSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyAuditEventsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/audit-events/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Create an external meeting ID
 */
export const transparencyExternalMeetingIdsCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyExternalMeetingIdsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TransparencyExternalMeetingIdsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyExternalMeetingIdsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/external-meeting-ids/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete an external meeting ID
 */
export const transparencyExternalMeetingIdsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyExternalMeetingIdsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<TransparencyExternalMeetingIdsDestroyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/external-meeting-ids/{id}/',
    ...options,
  })

/**
 * Create a general meeting
 */
export const transparencyGeneralMeetingsCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyGeneralMeetingsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TransparencyGeneralMeetingsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyGeneralMeetingsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/general-meetings/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get a general meeting by ID
 */
export const transparencyGeneralMeetingsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyGeneralMeetingsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<TransparencyGeneralMeetingsRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyGeneralMeetingsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/general-meetings/{id}/',
    ...options,
  })

/**
 * Update a general meeting (partial update)
 */
export const transparencyGeneralMeetingsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyGeneralMeetingsPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<TransparencyGeneralMeetingsPartialUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyGeneralMeetingsPartialUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/general-meetings/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search general meetings
 *
 * Search general meetings with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. general_meeting_names) are sent in the body to avoid overflowing URL-length limits. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const transparencyGeneralMeetingsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<TransparencyGeneralMeetingsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<TransparencyGeneralMeetingsSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyGeneralMeetingsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/general-meetings/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Create an instrument
 *
 * Creates an instrument, validated as defined by the instrument resource.
 */
export const transparencyInstrumentsCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyInstrumentsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TransparencyInstrumentsCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/instruments/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete an instrument
 *
 * Deletes the instrument.
 */
export const transparencyInstrumentsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyInstrumentsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<TransparencyInstrumentsDestroyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/instruments/{isin}/',
    ...options,
  })

/**
 * Get an instrument by ISIN
 *
 * Returns an instrument by its identifier, the ISIN.
 */
export const transparencyInstrumentsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyInstrumentsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<TransparencyInstrumentsRetrieveResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/instruments/{isin}/',
    ...options,
  })

/**
 * Replace an instrument
 *
 * Replaces every field on the instrument.
 */
export const transparencyInstrumentsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyInstrumentsUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<TransparencyInstrumentsUpdateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/instruments/{isin}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Fetch the minimal projection of many instruments at once
 *
 * Fetches instruments given a list of ISINs. Designed to be more performant than the list endpoint when only a subset of fields is needed.
 */
export const transparencyInstrumentsFetchMinimalCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyInstrumentsFetchMinimalCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TransparencyInstrumentsFetchMinimalCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/instruments/fetch-minimal/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search instruments
 *
 * Search instruments with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. isins, public_security_id_names) are sent in the body to avoid overflowing URL-length limits. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const transparencyInstrumentsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<TransparencyInstrumentsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<TransparencyInstrumentsSearchCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/instruments/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * List non-composite instruments not linked to any organization
 *
 * Returns the non-composite instruments which do not have an association to an organization.
 */
export const transparencyInstrumentsUnassociatedRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<TransparencyInstrumentsUnassociatedRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<TransparencyInstrumentsUnassociatedRetrieveResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/instruments/unassociated/',
    ...options,
  })

/**
 * Create an organization
 */
export const transparencyOrganizationsCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TransparencyOrganizationsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyOrganizationsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete an organization
 */
export const transparencyOrganizationsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<TransparencyOrganizationsDestroyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/{id}/',
    ...options,
  })

/**
 * Get an organization by ID
 */
export const transparencyOrganizationsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<TransparencyOrganizationsRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyOrganizationsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/{id}/',
    ...options,
  })

/**
 * Patch an organization (partial update)
 */
export const transparencyOrganizationsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<TransparencyOrganizationsPartialUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyOrganizationsPartialUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Replace an organization (full update)
 */
export const transparencyOrganizationsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<TransparencyOrganizationsUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyOrganizationsUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Upload a new logo for an organization
 */
export const transparencyOrganizationsLogoCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsLogoCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TransparencyOrganizationsLogoCreateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyOrganizationsLogoCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/{id}/logo/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create a proposal
 */
export const transparencyOrganizationsGeneralMeetingsProposalsCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsGeneralMeetingsProposalsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    TransparencyOrganizationsGeneralMeetingsProposalsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: transparencyOrganizationsGeneralMeetingsProposalsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/{org_id}/general-meetings/{gm_id}/proposals/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Get a proposal by ID
 */
export const transparencyOrganizationsGeneralMeetingsProposalsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsGeneralMeetingsProposalsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    TransparencyOrganizationsGeneralMeetingsProposalsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: transparencyOrganizationsGeneralMeetingsProposalsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/{org_id}/general-meetings/{gm_id}/proposals/{proposal_id}/',
    ...options,
  })

/**
 * Partially update a proposal (merges over the current version)
 *
 * Updates only the fields supplied in the request, preserving all others from the proposal's current version. Creates a new version, invalidating the previous one.
 */
export const transparencyOrganizationsGeneralMeetingsProposalsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsGeneralMeetingsProposalsPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    TransparencyOrganizationsGeneralMeetingsProposalsPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: transparencyOrganizationsGeneralMeetingsProposalsPartialUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/{org_id}/general-meetings/{gm_id}/proposals/{proposal_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Update a proposal (full replace of current version)
 */
export const transparencyOrganizationsGeneralMeetingsProposalsUpdate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsGeneralMeetingsProposalsUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<
    TransparencyOrganizationsGeneralMeetingsProposalsUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: transparencyOrganizationsGeneralMeetingsProposalsUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/{org_id}/general-meetings/{gm_id}/proposals/{proposal_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search proposals within a general meeting
 *
 * Search proposals with filters supplied in the request body. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const transparencyOrganizationsGeneralMeetingsProposalsSearchCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsGeneralMeetingsProposalsSearchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    TransparencyOrganizationsGeneralMeetingsProposalsSearchCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: transparencyOrganizationsGeneralMeetingsProposalsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/{org_id}/general-meetings/{gm_id}/proposals/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Look up an organization by external identifier
 */
export const transparencyOrganizationsGetByIdentifierCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsGetByIdentifierCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TransparencyOrganizationsGetByIdentifierCreateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyOrganizationsGetByIdentifierCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/get-by-identifier/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Resolve a batch of ISINs to organization names
 */
export const transparencyOrganizationsIsinsToNamesCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyOrganizationsIsinsToNamesCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TransparencyOrganizationsIsinsToNamesCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/isins-to-names/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search organizations
 *
 * Search organizations with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. names) are sent in the body to avoid overflowing URL-length limits. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const transparencyOrganizationsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<TransparencyOrganizationsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<TransparencyOrganizationsSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyOrganizationsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/organizations/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * List proposal classification codes
 */
export const transparencyProposalsClassificationCodesRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<TransparencyProposalsClassificationCodesRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<TransparencyProposalsClassificationCodesRetrieveResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/proposals/classification-codes/',
    ...options,
  })

/**
 * Count proposals per general meeting
 */
export const transparencyProposalsCountCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyProposalsCountCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TransparencyProposalsCountCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/proposals/count/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Fetch proposals across multiple general meetings
 *
 * Fetch proposals across multiple general meetings with optional votability filters. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const transparencyProposalsFetchCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyProposalsFetchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TransparencyProposalsFetchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyProposalsFetchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/proposals/fetch/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Fetch proposal resource names from identity UUIDs
 */
export const transparencyProposalsFetchNamesFromIdsCreate = <ThrowOnError extends boolean = false>(
  options: Options<TransparencyProposalsFetchNamesFromIdsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<TransparencyProposalsFetchNamesFromIdsCreateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/proposals/fetch-names-from-ids/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List SEC proposal category codes
 */
export const transparencyProposalsSecClassificationCodesRetrieve = <ThrowOnError extends boolean = false>(
  options?: Options<TransparencyProposalsSecClassificationCodesRetrieveData, ThrowOnError>
) =>
  (options?.client ?? client).get<TransparencyProposalsSecClassificationCodesRetrieveResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/proposals/sec-classification-codes/',
    ...options,
  })

/**
 * Search public security IDs
 *
 * Search public security IDs with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. names, values) are sent in the body to avoid overflowing URL-length limits. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const transparencyPublicSecurityIdsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<TransparencyPublicSecurityIdsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<TransparencyPublicSecurityIdsSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: transparencyPublicSecurityIdsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/transparency/public-security-ids/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Filter proxy intermediary ballot search results with cursor-based pagination.
 */
export const votingOperationsPiballotsFilterList = <ThrowOnError extends boolean = false>(
  options?: Options<VotingOperationsPiballotsFilterListData, ThrowOnError>
) =>
  (options?.client ?? client).get<VotingOperationsPiballotsFilterListResponses, unknown, ThrowOnError>({
    responseTransformer: votingOperationsPiballotsFilterListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-operations/piballots/filter',
    ...options,
  })

/**
 * Filter proxy intermediary meeting search results with cursor-based pagination. Returns meetings that are in scope for voting operations workflow, along with their scope information.
 */
export const votingOperationsPimeetingsFilterList = <ThrowOnError extends boolean = false>(
  options?: Options<VotingOperationsPimeetingsFilterListData, ThrowOnError>
) =>
  (options?.client ?? client).get<VotingOperationsPimeetingsFilterListResponses, unknown, ThrowOnError>({
    responseTransformer: votingOperationsPimeetingsFilterListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-operations/pimeetings/filter',
    ...options,
  })

/**
 * Get proposal set recommendation coverage detail
 *
 * Composes everything the recommendation coverage detail of one proposal set under one voting policy needs: every proposal in the set with its current proxy intermediary voting recommendation (and the provider voting recommendation it was matched from), plus the provider voting recommendations of the latest batch for the meeting and policy that remain unmatched. The batch is identified through a matched recommendation's PVR link; when no recommendation links a PVR, the batch fields are null and no unmatched recommendations are returned.
 */
export const votingPolicyProposalSetRecommendationCoverageDetailRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyProposalSetRecommendationCoverageDetailRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    VotingPolicyProposalSetRecommendationCoverageDetailRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyProposalSetRecommendationCoverageDetailRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/proposal-set-recommendation-coverage/detail/',
    ...options,
  })

/**
 * Search proposal set recommendation coverage
 *
 * Reports, for each proxy intermediary meeting, proposal set and voting policy, how far voting recommendation matching has progressed and the window of vote deadlines its ballots fall in. A row is returned while at least one of its ballots is still votable and the working day its earliest deadline effectively falls on is within the `due_in` window, so a proposal set stays listed for its remaining ballots after the earliest one has passed. Filters are supplied in the request body; pagination uses the `cursor` and `page_size` query parameters. Results are ordered by earliest vote deadline, soonest first. Supply `validation_statuses` to return only the rows whose recommendations are all checked, or only those with review outstanding.
 */
export const votingPolicyProposalSetRecommendationCoverageSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<VotingPolicyProposalSetRecommendationCoverageSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    VotingPolicyProposalSetRecommendationCoverageSearchCreateResponses,
    VotingPolicyProposalSetRecommendationCoverageSearchCreateErrors,
    ThrowOnError
  >({
    responseTransformer: votingPolicyProposalSetRecommendationCoverageSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/proposal-set-recommendation-coverage/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Create a provider voting recommendation
 *
 * Creates a provider voting recommendation. Validates that the parent voting policy exists. Returns 409 Conflict if an identical recommendation already exists.
 */
export const votingPolicyProviderVotingRecommendationsCreate = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyProviderVotingRecommendationsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<VotingPolicyProviderVotingRecommendationsCreateResponses, unknown, ThrowOnError>({
    responseTransformer: votingPolicyProviderVotingRecommendationsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/provider-voting-recommendations/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a provider voting recommendation
 *
 * Soft-deletes a provider voting recommendation by setting its delete_time.
 */
export const votingPolicyProviderVotingRecommendationsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyProviderVotingRecommendationsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<VotingPolicyProviderVotingRecommendationsDestroyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/provider-voting-recommendations/{id}/',
    ...options,
  })

/**
 * Match a provider voting recommendation to a proposal
 *
 * Creates a voting recommendation for a proposal from this provider voting recommendation (PVR), copying the PVR's instruction, rationale, proposal text/label/sequence number and id. The parent voting policy is taken from the PVR. Validates that the proposal exists, the instruction is valid for it, and the proxy intermediary deadline has not passed. Returns 409 Conflict if an active recommendation already exists for the policy and proposal; a soft-deleted recommendation is revived instead. If the PVR carries an external_meeting_id, a best-effort external meeting id mapping is created.
 */
export const votingPolicyProviderVotingRecommendationsMatchCreate = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyProviderVotingRecommendationsMatchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<VotingPolicyProviderVotingRecommendationsMatchCreateResponses, unknown, ThrowOnError>(
    {
      responseTransformer: votingPolicyProviderVotingRecommendationsMatchCreateResponseTransformer,
      security: [{ scheme: 'bearer', type: 'http' }],
      url: '/voting-policy/provider-voting-recommendations/{id}/match/',
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options.headers,
      },
    }
  )

/**
 * Fetch provider voting recommendations by version
 *
 * Returns all non-deleted provider voting recommendations for a specific meeting+policy batch version, identified by unique_meeting_policy_id and meeting_batch_version. The result is not paginated.
 */
export const votingPolicyProviderVotingRecommendationsFetchByVersionRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyProviderVotingRecommendationsFetchByVersionRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    VotingPolicyProviderVotingRecommendationsFetchByVersionRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyProviderVotingRecommendationsFetchByVersionRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/provider-voting-recommendations/fetch-by-version/',
    ...options,
  })

/**
 * Search provider voting recommendations
 *
 * Searches provider voting recommendations with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. isins, policy_ids) are sent in the body to avoid overflowing URL-length limits. Soft-deleted recommendations are always excluded. The `meeting_date` filter matches a single calendar day and cannot be combined with the inclusive `meeting_date_after` / `meeting_date_before` range bounds. Pagination uses the `cursor` and `page_size` query parameters.
 */
export const votingPolicyProviderVotingRecommendationsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<VotingPolicyProviderVotingRecommendationsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    VotingPolicyProviderVotingRecommendationsSearchCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyProviderVotingRecommendationsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/provider-voting-recommendations/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Upsert a proxy intermediary voting recommendation confidence score
 *
 * Creates or replaces the validation confidence score for the given algorithm against a proxy intermediary voting recommendation version. The confidence score must be between 0.0 and 1.0. Returns 201 when a new score is created and 200 when an existing score (same version and algorithm) is updated.
 */
export const votingPolicyProxyIntermediaryVotingRecommendationConfidenceScoresUpdate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<VotingPolicyProxyIntermediaryVotingRecommendationConfidenceScoresUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<
    VotingPolicyProxyIntermediaryVotingRecommendationConfidenceScoresUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyProxyIntermediaryVotingRecommendationConfidenceScoresUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/proxy-intermediary-voting-recommendation-confidence-scores/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create a proxy intermediary voting recommendation validation status
 *
 * Records a validation status against a proxy intermediary voting recommendation version. Statuses are append-only: recording a status never replaces an earlier one, and the current status of a version is its most recently created one. The status is attributed to the authenticated caller.
 */
export const votingPolicyProxyIntermediaryVotingRecommendationValidationStatusesCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyProxyIntermediaryVotingRecommendationValidationStatusesCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/proxy-intermediary-voting-recommendation-validation-statuses/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search proxy intermediary voting recommendation validation statuses
 *
 * Returns validation statuses matching the body filters, newest first. By default only the current status of each recommendation is returned; set include_history to return every status ever recorded. Filters are optional and combine with AND; the recommendation ids are taken from the body rather than the query string so a large set does not overflow URL-length limits.
 */
export const votingPolicyProxyIntermediaryVotingRecommendationValidationStatusesSearchCreate = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    VotingPolicyProxyIntermediaryVotingRecommendationValidationStatusesSearchCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer:
      votingPolicyProxyIntermediaryVotingRecommendationValidationStatusesSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/proxy-intermediary-voting-recommendation-validation-statuses/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Create a proxy intermediary voting recommendation
 *
 * Creates a proxy intermediary voting recommendation for a proposal under the given voting policy. Validates that the voting policy and proposal exist, the voting instruction is not no_action and is valid for the proposal, and the proxy intermediary submission deadline has not passed. Returns 409 Conflict if a live recommendation already exists for the policy and proposal.
 */
export const votingPolicyProxyIntermediaryVotingRecommendationsCreate = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyProxyIntermediaryVotingRecommendationsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    VotingPolicyProxyIntermediaryVotingRecommendationsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyProxyIntermediaryVotingRecommendationsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/proxy-intermediary-voting-recommendations/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a proxy intermediary voting recommendation
 *
 * Soft-deletes the recommendation by closing its current version: sets delete_time (and deleted_by_sub) on the version row. The identity and all version history are retained. Returns 404 if the recommendation does not exist or is already deleted.
 */
export const votingPolicyProxyIntermediaryVotingRecommendationsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyProxyIntermediaryVotingRecommendationsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    VotingPolicyProxyIntermediaryVotingRecommendationsDestroyResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/proxy-intermediary-voting-recommendations/{identity_id}/',
    ...options,
  })

/**
 * Match a proxy intermediary proposal to a provider voting recommendation
 *
 * Creates a proxy intermediary voting recommendation from a provider voting recommendation (PVR), copying the PVR's voting policy, instruction, rationale and proposal text/label/sequence number. The proxy intermediary proposal is the join target and supplies validation only. Validates that the PVR and proposal exist, the PVR's instruction is valid for the proposal, and the proxy intermediary submission deadline has not passed. Matching a proposal that is already live under the same voting policy supersedes it with a new version carrying the new PVR's values.
 */
export const votingPolicyProxyIntermediaryVotingRecommendationsMatchFromPvrCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<VotingPolicyProxyIntermediaryVotingRecommendationsMatchFromPvrCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    VotingPolicyProxyIntermediaryVotingRecommendationsMatchFromPvrCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyProxyIntermediaryVotingRecommendationsMatchFromPvrCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/proxy-intermediary-voting-recommendations/match-from-pvr/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search proxy intermediary voting recommendations
 *
 * Searches the current proxy intermediary voting recommendations with filters supplied in the request body. Filters that may contain large, unbounded collections (proposal, provider voting recommendation and voting policy id lists) are sent in the body to avoid overflowing URL-length limits. All filters are optional and combine with AND. Results are cursor-paginated.
 */
export const votingPolicyProxyIntermediaryVotingRecommendationsSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<VotingPolicyProxyIntermediaryVotingRecommendationsSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<
    VotingPolicyProxyIntermediaryVotingRecommendationsSearchCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyProxyIntermediaryVotingRecommendationsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/proxy-intermediary-voting-recommendations/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Get a proxy intermediary voting recommendation version
 *
 * Returns the version addressed by id exactly as recorded, whether it is the current version, a superseded one, or one closed by deletion. delete_time is null while the version is current.
 */
export const votingPolicyProxyIntermediaryVotingRecommendationsVersionsRetrieve = <
  ThrowOnError extends boolean = false,
>(
  options: Options<VotingPolicyProxyIntermediaryVotingRecommendationsVersionsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    VotingPolicyProxyIntermediaryVotingRecommendationsVersionsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyProxyIntermediaryVotingRecommendationsVersionsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/proxy-intermediary-voting-recommendations/versions/{id}/',
    ...options,
  })

/**
 * Create a voting policy
 *
 * Creates a voting policy. The id is server-generated. `available_to_investor_type` must contain at least one investor type. If supplied, `image_url` must be a Cloudinary URL.
 */
export const votingPolicyVotingPoliciesCreate = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<VotingPolicyVotingPoliciesCreateResponses, unknown, ThrowOnError>({
    responseTransformer: votingPolicyVotingPoliciesCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a voting policy
 *
 * Deletes a voting policy and cascades deletion of its policy documents (DB + S3). Returns 409 Conflict if any voting recommendations exist for the policy.
 */
export const votingPolicyVotingPoliciesDestroy = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<VotingPolicyVotingPoliciesDestroyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{id}/',
    ...options,
  })

/**
 * Get a voting policy
 *
 * Returns a single voting policy by its UUID, with the most recent voting policy document attached as `current_policy_document` (null if the policy has no documents).
 */
export const votingPolicyVotingPoliciesRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<VotingPolicyVotingPoliciesRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: votingPolicyVotingPoliciesRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{id}/',
    ...options,
  })

/**
 * Update a voting policy
 *
 * Partially updates a voting policy. Only fields present in the request body are updated; absent fields are left untouched.
 */
export const votingPolicyVotingPoliciesPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<VotingPolicyVotingPoliciesPartialUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: votingPolicyVotingPoliciesPartialUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * List voting policy documents
 *
 * Returns voting policy documents for a given voting policy, ordered by issue time descending. Supports pagination.
 */
export const votingPolicyVotingPoliciesDocumentsList = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesDocumentsListData, ThrowOnError>
) =>
  (options.client ?? client).get<VotingPolicyVotingPoliciesDocumentsListResponses, unknown, ThrowOnError>({
    responseTransformer: votingPolicyVotingPoliciesDocumentsListResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{voting_policy_id}/documents/',
    ...options,
  })

/**
 * Create a voting policy document
 *
 * Uploads a PDF and creates a document record for a voting policy. The request body must be the raw PDF file with Content-Type: application/pdf. The file must not exceed 10 MB. The issue_time must not be in the future.
 */
export const votingPolicyVotingPoliciesDocumentsCreate = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesDocumentsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<VotingPolicyVotingPoliciesDocumentsCreateResponses, unknown, ThrowOnError>({
    bodySerializer: null,
    responseTransformer: votingPolicyVotingPoliciesDocumentsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{voting_policy_id}/documents/',
    ...options,
    headers: {
      'Content-Type': 'application/pdf',
      ...options.headers,
    },
  })

/**
 * Get a voting policy document
 *
 * Returns a single voting policy document by its integer ID.
 */
export const votingPolicyVotingPoliciesDocumentsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesDocumentsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<VotingPolicyVotingPoliciesDocumentsRetrieveResponses, unknown, ThrowOnError>({
    responseTransformer: votingPolicyVotingPoliciesDocumentsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{voting_policy_id}/documents/{id}/',
    ...options,
  })

/**
 * Update a voting policy document
 *
 * Partially updates a voting policy document. Only title and issue_time may be changed.
 */
export const votingPolicyVotingPoliciesDocumentsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesDocumentsPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<VotingPolicyVotingPoliciesDocumentsPartialUpdateResponses, unknown, ThrowOnError>({
    responseTransformer: votingPolicyVotingPoliciesDocumentsPartialUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{voting_policy_id}/documents/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Create a voting recommendation
 *
 * Creates a voting recommendation for a proposal under the given voting policy. Validates that the proposal exists, the voting instruction is valid for that proposal, and the proxy intermediary deadline has not passed. Returns 409 Conflict if an active recommendation already exists for the policy and proposal; a soft-deleted recommendation is revived instead.
 */
export const votingPolicyVotingPoliciesVotingRecommendationsCreate = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesVotingRecommendationsCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    VotingPolicyVotingPoliciesVotingRecommendationsCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyVotingPoliciesVotingRecommendationsCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{voting_policy_id}/voting-recommendations/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Delete a voting recommendation
 *
 * Soft-deletes a voting recommendation.
 */
export const votingPolicyVotingPoliciesVotingRecommendationsDestroy = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesVotingRecommendationsDestroyData, ThrowOnError>
) =>
  (options.client ?? client).delete<
    VotingPolicyVotingPoliciesVotingRecommendationsDestroyResponses,
    unknown,
    ThrowOnError
  >({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{voting_policy_id}/voting-recommendations/{id}/',
    ...options,
  })

/**
 * Get a voting recommendation
 *
 * Returns a single voting recommendation by its version ID.
 */
export const votingPolicyVotingPoliciesVotingRecommendationsRetrieve = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesVotingRecommendationsRetrieveData, ThrowOnError>
) =>
  (options.client ?? client).get<
    VotingPolicyVotingPoliciesVotingRecommendationsRetrieveResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyVotingPoliciesVotingRecommendationsRetrieveResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{voting_policy_id}/voting-recommendations/{id}/',
    ...options,
  })

/**
 * Update a voting recommendation
 *
 * Updates a voting recommendation's voting_instruction and/or rationale. Creates a new version of the recommendation, invalidating the previous one. Re-validates the voting instruction and proxy deadline on each update. Returns 409 Conflict if no fields change, leaving the current version active.
 */
export const votingPolicyVotingPoliciesVotingRecommendationsPartialUpdate = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesVotingRecommendationsPartialUpdateData, ThrowOnError>
) =>
  (options.client ?? client).patch<
    VotingPolicyVotingPoliciesVotingRecommendationsPartialUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyVotingPoliciesVotingRecommendationsPartialUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{voting_policy_id}/voting-recommendations/{id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Update a voting recommendation from a provider voting recommendation
 *
 * Updates an existing voting recommendation from a provider voting recommendation (PVR), creating a new version. Copies the PVR's voting_instruction, rationale, proposal_sequence_number and id onto the new version; proposal_name, proposal_text and proposal_label are preserved. Re-validates the voting instruction and proxy deadline. Returns 404 if the voting recommendation or the PVR does not exist.
 */
export const votingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreate = <
  ThrowOnError extends boolean = false,
>(
  options: Options<VotingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    VotingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyVotingPoliciesVotingRecommendationsUpdateFromPvrCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{voting_policy_id}/voting-recommendations/{id}/update-from-pvr/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search voting recommendations
 *
 * Searches the current voting recommendations for a voting policy, one per proposal, with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. proposal_names) are sent in the body to avoid overflowing URL-length limits. Results are cursor-paginated.
 */
export const votingPolicyVotingPoliciesVotingRecommendationsSearchCreate = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingPoliciesVotingRecommendationsSearchCreateData, ThrowOnError>
) =>
  (options.client ?? client).post<
    VotingPolicyVotingPoliciesVotingRecommendationsSearchCreateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyVotingPoliciesVotingRecommendationsSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/{voting_policy_id}/voting-recommendations/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })

/**
 * Search voting policies
 *
 * Searches voting policies with filters supplied in the request body. Filters that may contain large, unbounded collections (e.g. voting_policy_ids) are sent in the body to avoid overflowing URL-length limits. Results include the most recent voting policy document per policy (null if none exist).
 */
export const votingPolicyVotingPoliciesSearchCreate = <ThrowOnError extends boolean = false>(
  options?: Options<VotingPolicyVotingPoliciesSearchCreateData, ThrowOnError>
) =>
  (options?.client ?? client).post<VotingPolicyVotingPoliciesSearchCreateResponses, unknown, ThrowOnError>({
    responseTransformer: votingPolicyVotingPoliciesSearchCreateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-policies/search/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  })

/**
 * Upsert a voting recommendation confidence score
 *
 * Creates or replaces the validation confidence score for a voting recommendation version. The confidence score must be between 0.0 and 1.0. Returns 201 when a new score is created and 200 when an existing score is updated.
 */
export const votingPolicyVotingRecommendationConfidenceScoresUpdate = <ThrowOnError extends boolean = false>(
  options: Options<VotingPolicyVotingRecommendationConfidenceScoresUpdateData, ThrowOnError>
) =>
  (options.client ?? client).put<
    VotingPolicyVotingRecommendationConfidenceScoresUpdateResponses,
    unknown,
    ThrowOnError
  >({
    responseTransformer: votingPolicyVotingRecommendationConfidenceScoresUpdateResponseTransformer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/voting-policy/voting-recommendation-confidence-scores/{version_id}/',
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  })
